import React, { useState, useRef, useEffect } from 'react';
import { Search, Plus, Trash2, ChevronDown, ShoppingCart, Save, Download, RefreshCw, Wifi, WifiOff, User, MapPin,X,AlertCircle,NotebookPen,Trash, Trash2Icon,Mail,Send,Info, CheckCircle,StickyNote,Settings,LogOut } from 'lucide-react';
import { 
  fetchProductsFromOdoo, 
  testConnection, 
  fetchProductById, 
  searchRead
//   fetchProductCategories 
} from './dataService'; // Import your data service

import OdooJsonRpcService from "./OdooJsonRpcService";

// /// Toast component Start
// 2. ADD THIS CUSTOM HOOK AT THE TOP OF YOUR FILE (outside component)
const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const showToast = (message, type = 'info', duration = 4000) => {
    const id = Date.now();
    const newToast = { id, message, type };
    
    setToasts(prev => [...prev, newToast]);
    
    setTimeout(() => {
      removeToast(id);
    }, duration);
  };

  const removeToast = (id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  };

  return {
    toasts,
    showToast,
    removeToast,
    showSuccess: (message) => showToast(message, 'success'),
    showError: (message) => showToast(message, 'error'),
    showInfo: (message) => showToast(message, 'info')
  };
};

// 3. ADD THIS COMPONENT AT THE TOP OF YOUR FILE (outside your main component)
const Toast = ({ toast, onClose }) => {
  const getIcon = () => {
    switch (toast.type) {
      case 'success':
        return <CheckCircle className="w-5 h-5 text-green-500" />;
      case 'error':
        return <AlertCircle className="w-5 h-5 text-red-500" />;
      case 'info':
        return <Info className="w-5 h-5 text-blue-500" />;
      default:
        return <Info className="w-5 h-5 text-gray-500" />;
    }
  };

  const getBgColor = () => {
    switch (toast.type) {
      case 'success':
        return 'bg-green-50 border-green-200';
      case 'error':
        return 'bg-red-50 border-red-200';
      case 'info':
        return 'bg-blue-50 border-blue-200';
      default:
        return 'bg-gray-50 border-gray-200';
    }
  };

  return (
    <div className={`flex items-center justify-between p-3 sm:p-4 mb-2 sm:mb-3 rounded-lg border shadow-lg transition-all duration-300 ${getBgColor()}`}>
      <div className="flex items-center min-w-0 flex-1">
        {getIcon()}
        <span className="ml-2 sm:ml-3 text-xs sm:text-sm font-medium text-gray-800 break-words">
          {toast.message}
        </span>
      </div>
      <button
        onClick={() => onClose(toast.id)}
        className="ml-2 sm:ml-4 text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

const ToastContainer = ({ toasts, onClose }) => {
  if (toasts.length === 0) return null;
  
  return (
    <>
      {/* Mobile: Full width at top */}
      <div className="fixed top-4 left-4 right-4 z-50 space-y-2 sm:hidden">
        {toasts.map((toast) => (
          <Toast key={toast.id} toast={toast} onClose={onClose} />
        ))}
      </div>
      
      {/* Desktop: Right side */}
      <div className="hidden sm:block fixed top-4 right-4 z-50 w-full max-w-sm space-y-2">
        {toasts.map((toast) => (
          <Toast key={toast.id} toast={toast} onClose={onClose} />
        ))}
      </div>
    </>
  );
};
/// Toast component Ends 
// Model component start 

// If you want to add a confirmation modal, add this hook to DynamicProductRows:
const useModal = () => {
  const [modal, setModal] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'info',
    onConfirm: null,
    showCancel: false
  });

  const showModal = (config) => {
    setModal({
      isOpen: true,
      ...config
    });
  };

  const closeModal = () => {
    setModal(prev => ({ ...prev, isOpen: false }));
  };

  const showConfirm = (message, onConfirm, title = 'Confirm') => {
    showModal({ 
      message, 
      title, 
      type: 'warning', 
      onConfirm: () => {
        onConfirm();
        closeModal();
      },
      showCancel: true 
    });
  };

  return {
    modal,
    showModal,
    closeModal,
    showConfirm
  };
};

// model component end

const DynamicProductRows = ({ userId,onLogout, userInfo  }) => {
   const { toasts, showSuccess, showError, showInfo, removeToast } = useToast();
   const { modal, closeModal, showConfirm } = useModal();
  // Initial row state
  const getInitialRow = () => ({
    id: 1,
    selectedProduct: null,
    quantity: 1,
    searchTerm: '',
    isDropdownOpen: false
  });

  const [rows, setRows] = useState([getInitialRow()]);
  const [rowIdCounter, setRowIdCounter] = useState(2);
  const [savedLists, setSavedLists] = useState([]);
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [listName, setListName] = useState('');
  const [showLoadModal, setShowLoadModal] = useState(false);
  const [showClearModal, setShowClearModal] = useState(false);
  const [modalLists, setModalLists] = useState([]);

  // Odoo related states
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [lastSync, setLastSync] = useState(null);
  const [autoSync, setAutoSync] = useState(true);
  const [syncError, setSyncError] = useState(null);
  const [connectionStatus, setConnectionStatus] = useState('unknown');
  const [result, setResult] = useState({ status: 'idle', error: null });
  // setResult({ status: 'success', error: null });
  // setResult({ status: 'error', error: err.message });

  const [odooService] = useState(new OdooJsonRpcService({
        url: 'https://mimir.xyz',
        db: 'production',
        username: 'salasar.developer@icloud.com',
        password: 't4a39W5@3KnC'
    }));
/************* customer block start */ 
// const [customers, setCustomers] = useState([
//     {
//       id: 1,
//       name: "John Smith",
//       address: "123 Main St, New York, NY 10001",
//       email: "john.smith@email.com",
//       contactNumber: "+1-555-0123",
//       contactPerson: "John Smith"
//     },
//     {
//       id: 2,
//       name: "ABC Corp",
//       address: "456 Business Ave, Los Angeles, CA 90210",
//       email: "contact@abccorp.com",
//       contactNumber: "+1-555-0456",
//       contactPerson: "Sarah Johnson"
//     },
//     {
//       id: 3,
//       name: "Tech Solutions Ltd",
//       address: "789 Innovation Blvd, San Francisco, CA 94105",
//       email: "info@techsolutions.com",
//       contactNumber: "+1-555-0789",
//       contactPerson: "Mike Chen"
//     }
//   ]); 
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerSearchTerm, setCustomerSearchTerm] = useState('');
  const [isCustomerDropdownOpen, setIsCustomerDropdownOpen] = useState(false);
  const [showAddCustomerForm, setShowAddCustomerForm] = useState(false);
  const [newCustomer, setNewCustomer] = useState({
    name: '',
    address: '',
    email: '',
    contactNumber: '',
    contactPerson: ''
  });
const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

const [currentLoadedListId, setCurrentLoadedListId] = useState(null);
const [currentListData, setCurrentListData] = useState({
    rows: [],
    selectedCustomer: null,
    projectName: '',
    notesInfo: ''
  });
  const [lists, setLists] = useState([]);
/************* customer block end */  
/* All or mail block satrt */
const [projectName, setProjectName] = useState('');
const [notesInfo, setNotesInfo] = useState('');
const [showMailModal, setShowMailModal] = useState(false);
const [mailError, setMailError] = useState('');
const [isSendingMail, setIsSendingMail] = useState(false);


const handleLogoutClick = () => {
    showConfirm(
      'Are you sure you want to logout? Any unsaved changes will be lost.',
      () => {
        showSuccess('Logged out successfully!');
        setTimeout(() => {
          onLogout();
        }, 1000);
      },
      'Logout'
    );
  };

  // Alternative: Simple logout without confirmation
  const handleSimpleLogout = () => {
    onLogout();
    showSuccess('Logged out successfully!');
  };

  // ✅ FIXED: Generate current quote data from actual form state
const getCurrentQuoteData = () => {
  const validRows = rows.filter(row => row.selectedProduct && row.quantity >= 1);
  
  const items = validRows.map(row => ({
    id: row.id,
    product: row.selectedProduct,
    quantity: row.quantity,
    searchTerm: row.searchTerm,
    price: row.selectedProduct?.price || 0,
    total: (row.selectedProduct?.price || 0) * row.quantity
  }));

  const subtotal = items.reduce((sum, item) => sum + item.total, 0);
  const taxRate = 0.10; // 10% tax - adjust as needed
  const tax = subtotal * taxRate;
  const total = subtotal + tax;

  return {
    customer: selectedCustomer,
    projectName: projectName,
    notesInfo: notesInfo,
    validRows: validRows,
    items: items,
    subtotal: subtotal,
    tax: tax,
    total: total,
    createdAt: new Date().toISOString()
  };
};

const validateQuoteData = () => {
  const errors = [];
  
  if (!selectedCustomer) {
    errors.push('Please select a customer');
  }
  
  if (!projectName.trim()) {
    errors.push('Please enter a project name');
  }
  
  const validRows = rows.filter(row => row.selectedProduct && row.quantity >= 1);
  if (validRows.length === 0) {
    errors.push('Please select at least one product with quantity ≥ 1');
  }
  
  const invalidQuantityRows = rows.filter(row => row.selectedProduct && row.quantity < 1);
  if (invalidQuantityRows.length > 0) {
    errors.push('All selected products must have quantity ≥ 1');
  }
  
  return errors;
};

// Calculate quote totals
const calculateQuoteTotals = () => {
  const validRows = rows.filter(row => row.selectedProduct && row.quantity >= 1);
  const subtotal = validRows.reduce((total, row) => {
    return total + (row.selectedProduct.price * row.quantity);
  }, 0);
  
  return {
    validRows,
    subtotal,
    tax: subtotal * 0.1, // 10% tax
    total: subtotal * 1.1
  };
};

// Send mail function
const handleSendMail = async () => {

  // Check if user is online
  if (!navigator.onLine) {
    showError('You are currently offline. Please connect to the internet to send emails.');
    // Optional: You could also set a state to retry when back online
    return;
  }

  const validationErrors = validateQuoteData();
  
  if (validationErrors.length > 0) {
    setMailError(validationErrors.join(', '));
    return;
  }
  
  setMailError('');
   refreshAllListStates();
  setShowMailModal(true);
};

const refreshAllListStates = () => {
  const freshLists = JSON.parse(localStorage.getItem('savedProductLists') || '[]');
  setLists(freshLists);
  // Add any other list-related state updates here
  console.log('🔄 Refreshed all list states');
};





// Confirm and send mail.  but issues is exiting list deleted
// const confirmSendMail = async () => {
//   setIsSendingMail(true);
  
//   try {

//     if (!selectedCustomer.email || selectedCustomer.email.trim() === '') {
//       showError('Cannot send quote: Customer email address is missing!\n\nPlease add an email address for this customer and try again.');
//       return;
//     }
//     // console.log('📝 Before auto-save - localStorage contents:', 
//     //   JSON.parse(localStorage.getItem('savedProductLists') || '[]'));
//       const currentQuoteData = getCurrentQuoteData();
//       console.log('📋 Current quote data:', currentQuoteData);
//    // const listId = autoSaveCurrentList();
//     const listId = autoSaveCurrentList(getCurrentQuoteData());

//     // Check localStorage immediately after auto-save
//     const listsAfterAutoSave = JSON.parse(localStorage.getItem('savedProductLists') || '[]');
//     console.log('💾 After auto-save - localStorage contents:', listsAfterAutoSave);

//     const quoteData = {
//       customer: selectedCustomer,
//       projectName: projectName.trim(),
//       notesInfo: notesInfo.trim(),
//       items: rows.filter(row => row.selectedProduct && row.quantity >= 1).map(row => ({
//         product: row.selectedProduct,
//         quantity: row.quantity,
//         unitPrice: row.selectedProduct.price,
//         total: row.selectedProduct.price * row.quantity
//       })),
//       ...calculateQuoteTotals(),
//       createdAt: new Date().toISOString()
//     };
//   // Prepare data for PHP API
//     const formData = new FormData();
//     formData.append('name', selectedCustomer.name);
//     formData.append('email', selectedCustomer.email);
//     formData.append('customer_id', selectedCustomer.id || '');
//     formData.append('customer_address', selectedCustomer.address || '');
//     formData.append('customer_phone', selectedCustomer.phone || selectedCustomer.contact || '');
//     formData.append('contact_person', selectedCustomer.contactPerson || selectedCustomer.contact_person || '');
//     formData.append('project_name', projectName.trim());
//     formData.append('notes', notesInfo.trim());
//     formData.append('quote_data', JSON.stringify(quoteData));
//     formData.append('total_amount', quoteData.total.toFixed(2));
//     formData.append('total_items', quoteData.items.length.toString());
    
//     // Add individual items as JSON string
//     formData.append('items', JSON.stringify(quoteData.items));

//     // Debug: Log FormData contents
//     console.log('FormData contents:');
//     for (let pair of formData.entries()) {
//       console.log(pair[0] + ': ' + pair[1]);
//     }
//     console.log('Sending quote data:', quoteData);
//     debugListStructure();
//     // Call your PHP API
//     const response = await fetch('https://salasartech.com/datasheet/api/reactmail', { // Adjust path as needed
//       method: 'POST',
//       body: formData
//     });
//     console.log('🌐 API Response Status:', response.status);

//     if (!response.ok) {
//       throw new Error(`HTTP error! status: ${response.status}`);
//     }
//     const result = await response.json();
//     console.log('✅ API Response:', result);
//     debugListStructure();
//     if (result.success) {
//       // showSuccess(`Quote successfully sent to ${selectedCustomer.email}!\n\nProject: ${projectName}\nAdditional Info: ${notesInfo}\nItems: ${quoteData.items.length}\nTotal: $${quoteData.total.toFixed(2)}`);
//       showSuccess(`Quote successfully sent to ${selectedCustomer.email}!\n\nProject: ${projectName}\nAdditional Info: ${notesInfo}\nItems: ${quoteData.items.length}`);
//       const currentLists = JSON.parse(localStorage.getItem('savedProductLists') || '[]');
//       console.log('📋 Current lists from localStorage:', currentLists);

//       if (currentLists.length > 0) {
       

//       const expectedListName = `${selectedCustomer.name} - ${projectName.trim()}`;
//         console.log('🔍 Looking for list with name:', expectedListName);
//         console.log('🔍 Or list with ID:', listId);
        
//         // Find the list that matches either the ID or the current customer/project
//         let targetList = null;
        
//         // First try to find by ID (most reliable)
//         targetList = currentLists.find(list => list.id === listId);
//         console.log('🎯 Found by ID:', targetList);
        
//         // If not found by ID, try to find by name pattern
//         if (!targetList) {
//           targetList = currentLists.find(list => 
//             list.name.includes(selectedCustomer.name) && 
//             list.name.includes(projectName.trim())
//           );
//           console.log('🎯 Found by name pattern:', targetList);
//         }
        
//         // If still not found, get the most recent one as fallback
//         if (!targetList) {
//           const sortedLists = [...currentLists].sort((a, b) => {
//             const timeA = new Date(a.lastModified || a.createdAt).getTime();
//             const timeB = new Date(b.lastModified || b.createdAt).getTime();
//             return timeB - timeA;
//           });
//           targetList = sortedLists[0];
//           console.log('🎯 Using most recent as fallback:', targetList);
//         }
        
//         if (targetList) {
//           console.log('✅ Target list found:', targetList.name, targetList.id);
          
//           // Update the target list
//           const updatedLists = currentLists.map(list => {
//             if (list.id === targetList.id) {
//               return {
//                 ...list,
//                 mailSent: true,
//                 mailSentRevisionKey: generateRevisionKey(),
//                 lastModified: new Date().toISOString(),
//                 revisionKey: generateRevisionKey(),
//                 version: (list.version || 0) + 1,
//                 // Ensure the current data is also preserved
//                 // data: {
//                 //   ...list.data, // Keep existing data
//                 //   // Update with current data if needed
//                 //   customer: selectedCustomer,
//                 //   projectName: projectName.trim(),
//                 //   notesInfo: notesInfo.trim(),
//                 //   rows: rows,
//                 //   lastModified: new Date().toISOString()
//                 // }
//               };
//               // console.log('🔄 Updated list data keys:', Object.keys(updatedList));
//               // console.log('📦 Updated list items count:', updatedList.data?.rows?.length || 0);
              
//               // return updatedList;
//             }
//             return list;
//           });

         
//         saveListsToStorage(updatedLists);
//          // Update component state - THIS IS CRUCIAL
//         setLists(updatedLists);
//         // Debug: Verify localStorage contents

//           setTimeout(() => {
//             const freshLists = JSON.parse(localStorage.getItem('savedProductLists') || '[]');
//             setLists(freshLists);
//             console.log('🔄 Force refreshed lists state');
//           }, 100);
          
//           console.log('✅ List updated and state refreshed');
//           console.log('✅ List successfully updated with mailSent: true');
          
//           // Verify the update
//           const verifyLists = JSON.parse(localStorage.getItem('savedProductLists') || '[]');
//           const updatedList = verifyLists.find(list => list.id === targetList.id);
//           console.log('🔍 Verification - Updated list:', updatedList);
//           } else {
//           console.error('❌ No suitable list found to update');
//         }
//       }
//           setShowMailModal(false);
         

//     } else {
//       // Handle validation errors from PHP
//       let errorMessage = 'Failed to send quote:\n';
//       if (result.errors) {
//         Object.values(result.errors).forEach(error => {
//           errorMessage += `• ${error}\n`;
//         });
//       } else {
//         errorMessage += result.message || 'Unknown error occurred.';
//       }
//       showError(errorMessage);
//     }
    
//   } catch (error) {
//     console.error('Error sending mail:', error);
//     showError('Failed to send quote. Please check your connection and try again.');
//   } finally {
//     setIsSendingMail(false);
//   }

//   // old code
//   //   // Replace this with your actual API call
//   //   await new Promise(resolve => setTimeout(resolve, 2000));
      
//   //   console.log('Quote data to be sent:', quoteData);
    
//   //   // alert(`Quote successfully sent to ${selectedCustomer.email}!\n\nProject: ${projectName}\nItems: ${quoteData.items.length}\nTotal: $\${quoteData.total.toFixed(2)}`);
//   //   // alert(`Quote successfully sent to Salasar.developer@icloud.com !\n\nProject: ${projectName}\nItems: ${quoteData.items.length}\nTotal: $\${quoteData.total.toFixed(2)}`);
//   //   showSuccess(`Quote successfully sent to Salasar.developer@icloud.com !\n\nProject: ${projectName}\n  Additional Info:${notesInfo} \nItems: ${quoteData.items.length}\nTotal: $\${quoteData.total.toFixed(2)}`);
    
//   //   setShowMailModal(false);
    
//   // } catch (error) {
//   //   console.error('Error sending mail:', error);
//   //   // alert('Failed to send quote. Please try again.');
//   //   showError('Failed to send quote. Please try again.');
//   // } finally {
//   //   setIsSendingMail(false);
//   // }
// };
useEffect(() => {
  console.log('🔄 Lists state changed:', lists.length, 'lists');
  lists.forEach((list, index) => {
    console.log(`   ${index + 1}. ${list.name} - mailSent: ${list.mailSent || false}`);
  });
}, [lists]);

useEffect(() => {
    const handleStorageChange = () => {
        const stored = localStorage.getItem('savedProductLists');
        if (stored) {
            // setProductLists(JSON.parse(stored));
            setSavedLists(JSON.parse(stored));
        }
    };
    
    // Listen for storage events
    window.addEventListener('storage', handleStorageChange);
    
    return () => window.removeEventListener('storage', handleStorageChange);
}, []);

// Modified autoSaveCurrentList for mail sending - always creates NEW list
const autoSaveForMail = (quoteData) => {
  const customerName = quoteData.customer?.name || 'Unknown Customer';
  const projectName = quoteData.projectName || 'Untitled Project';
  const cleanCustomerName = customerName.length > 30 
    ? customerName.substring(0, 30) + '...' 
    : customerName;


  console.log('🗑️ Preparing to delete existing list and create new one for mail');

   let updatedLists = [...lists];
  let newVersion = 1;
  let baseName = `${cleanCustomerName} - ${projectName}`;
   let parentId = null; // Track the correct parent ID

  if (currentLoadedListId) {
    const existingListIndex = lists.findIndex(list => list.id === currentLoadedListId);
    if (existingListIndex !== -1) {
      const existingList = lists[existingListIndex];
      console.log('🗑️ Deleting existing list:', existingList.name, existingList.id);
      
      if (existingList.mailSent === false) {
        // Remove the existing list
        console.log('🗑️ Mail not sent, deleting existing list and creating new one');
        updatedLists = [
          ...lists.slice(0, existingListIndex),
          ...lists.slice(existingListIndex + 1)
        ];
        newVersion = existingList.version || 1;
        parentId = existingList.parentListId; // Pr
      }
      else if (existingList.mailSent === true) {
        // Calculate next version number
       const sameNameLists = lists.filter(list => {
          const listBaseName = list.name.replace(/ \(v\d+\)$/, ''); // Remove version suffix
          return listBaseName === baseName;
        });
        
        newVersion = Math.max(
          ...sameNameLists.map(list => list.version || 1),
          existingList.version || 1
        ) + 1;
         // Set parent ID to the original list (version 1) or current list if it's already a version
        parentId = existingList.parentListId || existingList.id;
        

      }
      
      console.log('✅ Deleted existing list. Lists count:', updatedLists.length);
    }
  }
  // Generate custom name with version if > 1
  const customName = newVersion > 1 
    ? `${baseName} (v${newVersion})`
    : baseName;

  // 2. CREATE completely NEW list with unique ID
  const newList = {
    id: generateUniqueKey(), // Always generate new unique ID
    name: customName,
    createdAt: new Date().toISOString(),
    lastModified: new Date().toISOString(),
    revisionKey: generateRevisionKey(),
    mailSent: false, // Will be set to true after successful mail send
    mailSentRevisionKey: null,
    version:newVersion,
    parentListId: newVersion > 1 ? currentLoadedListId : null,
    products: quoteData.validRows.map(row => ({
      product: {
        id: row.selectedProduct?.id,
        name: row.selectedProduct?.name || row.searchTerm,
        price: row.selectedProduct?.price || 0,
        unit: row.selectedProduct?.unit || '',
        category: row.selectedProduct?.category || ''
      },
      quantity: row.quantity,
      subtotal: (row.selectedProduct?.price || 0) * row.quantity
    })),
    
    customer: {
      id: quoteData.customer?.id,
      name: quoteData.customer?.name,
      email: quoteData.customer?.email,
      phone: quoteData.customer?.phone,
      mobile: quoteData.customer?.mobile,
      address: quoteData.customer?.address,
      createdAt: quoteData.customer?.createdAt
    },
    
    project: quoteData.projectName,
    notesInfo: quoteData.notesInfo,
    
    quoteData: {
      subtotal: quoteData.subtotal,
      tax: quoteData.tax,
      total: quoteData.total,
      taxRate: quoteData.tax / quoteData.subtotal,
      itemCount: quoteData.validRows.length,
      generatedAt: quoteData.createdAt
    },
    // Metadata for tracking
    isMailVersion: true,
    createdForMail: true
  };

  // 3. Add new list to the array
  updatedLists = [...updatedLists, newList];
  
  // 4. Save and update state
  saveListsToStorage(updatedLists);
  setLists(updatedLists);
  setSavedLists(updatedLists);
  setCurrentLoadedListId(newList.id);
  
  console.log('✅ Created new list for mail:', newList.id);
  console.log('📊 Final lists count:', updatedLists.length);
  console.log('📦 New list has products:', newList.products.length);
  

  return newList.id;
};

// Helper function to mark mail as sent
const markMailAsSent = (listId, mailSentData = {}) => {
  const updatedLists = lists.map(list => {
    if (list.id === listId) {
      return {
        ...list,
        mailSent: true,
        mailSentAt: new Date().toISOString(),
        mailSentRevisionKey: generateRevisionKey(),
        mailSentData: {
          sentTo: mailSentData.sentTo || list.customer?.email,
          sentBy: mailSentData.sentBy || 'system',
          sentAt: new Date().toISOString(),
          ...mailSentData
        }
      };
    }
    return list;
  });
  
  saveListsToStorage(updatedLists);
  setLists(updatedLists);
  setSavedLists(updatedLists);
  
  console.log('📮 Marked mail as sent for list:', listId);
};

// Helper function to get list version history
const getListVersionHistory = (baseListId) => {
  const baseList = lists.find(list => list.id === baseListId);
  if (!baseList) return [];
  
  const baseName = baseList.name.replace(/ \(v\d+\)$/, ''); // Remove version suffix
  
  return lists
    .filter(list => 
      list.name.startsWith(baseName) || 
      list.parentListId === baseListId ||
      list.id === baseListId
    )
    .sort((a, b) => (a.version || 1) - (b.version || 1));
};

const confirmSendMail = async () => {
  setIsSendingMail(true);
  
  try {
    // Email validation BEFORE auto-save
    if (!selectedCustomer.email || selectedCustomer.email.trim() === '') {
      showError('Cannot send quote: Customer email address is missing!\n\nPlease add an email address for this customer and try again.');
      return;
    }
    // CRITICAL: Get lists BEFORE auto-save to preserve them
    const listsBeforeAutoSave = JSON.parse(localStorage.getItem('savedProductLists') || '[]');
    
     console.log('📋 Lists BEFORE auto-save:', listsBeforeAutoSave);
     console.log('📋 Lists BEFORE auto-save:', listsBeforeAutoSave.length);

    // Auto-save the current list and get the returned list ID
    const listId = autoSaveCurrentList(getCurrentQuoteData());
    //const listId = autoSaveForMail(getCurrentQuoteData());
    console.log('🆔 Auto-saved list ID:', listId);

    // Get lists AFTER auto-save to see what changed
    const listsAfterAutoSave = JSON.parse(localStorage.getItem('savedProductLists') || '[]');
      console.log('📋 Lists AFTER auto-save:', listsAfterAutoSave.length);
    // Check if lists were lost during auto-save
    if (listsAfterAutoSave.length < listsBeforeAutoSave.length) {
      console.error('❌ WARNING: Lists were lost during auto-save!');
      console.log('Before:', listsBeforeAutoSave.map(l => ({ id: l.id, name: l.name })));
      console.log('After:', listsAfterAutoSave.map(l => ({ id: l.id, name: l.name })));
    }
    
    const quoteData = {
      customer: selectedCustomer,
      projectName: projectName.trim(),
      notesInfo: notesInfo.trim(),
      items: rows.filter(row => row.selectedProduct && row.quantity >= 1).map(row => ({
        product: row.selectedProduct,
        quantity: row.quantity,
        unitPrice: row.selectedProduct.price,
        total: row.selectedProduct.price * row.quantity
      })),
      ...calculateQuoteTotals(),
      createdAt: new Date().toISOString()
    };

    // Prepare data for PHP API
    const formData = new FormData();
    formData.append('name', selectedCustomer.name);
    formData.append('email', selectedCustomer.email.trim());
    formData.append('customer_id', selectedCustomer.id || '');
    formData.append('customer_address', selectedCustomer.address || '');
    formData.append('customer_phone', selectedCustomer.phone || selectedCustomer.contact || '');
    formData.append('contact_person', selectedCustomer.contactPerson || selectedCustomer.contact_person || '');
    formData.append('project_name', projectName.trim());
    formData.append('notes', notesInfo.trim());
    formData.append('quote_data', JSON.stringify(quoteData));
    formData.append('total_amount', quoteData.total.toFixed(2));
    formData.append('total_items', quoteData.items.length.toString());
    formData.append('items', JSON.stringify(quoteData.items));

    console.log('📧 Sending quote to:', selectedCustomer.email);

    // Call your PHP API
    const response = await fetch('https://salasartech.com/datasheet/api/reactmail', {
      method: 'POST',
      body: formData
    });

    console.log('🌐 API Response Status:', response.status);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    console.log('✅ API Response:', result);

    if (result.success) {
      showSuccess(`Quote successfully sent to ${selectedCustomer.email}!\n\nProject: ${projectName}\nAdditional Info: ${notesInfo}\nItems: ${quoteData.items.length}`);
      
      // Get current lists from localStorage
      const currentLists = JSON.parse(localStorage.getItem('savedProductLists') || '[]');
      console.log('📋 All lists in localStorage:', currentLists);
      
      markMailAsSent(listId, {
        sentTo: selectedCustomer?.email,
        sentBy: 'user', // or get from auth context
        response: response
      });
      if (currentLists.length > 0) {
        // Create the expected list name for matching
        const expectedListName = `${selectedCustomer.name} - ${projectName.trim()}`;
        console.log('🔍 Looking for list with name:', expectedListName);
        console.log('🔍 Or list with ID:', listId);
        
        // Find the list that matches either the ID or the current customer/project
        let targetList = null;
        
        // First try to find by ID (most reliable)
        targetList = currentLists.find(list => list.id === listId);
        console.log('🎯 Found by ID:', targetList);
        
        // If not found by ID, try to find by name pattern
        if (!targetList) {
          targetList = currentLists.find(list => 
            list.name.includes(selectedCustomer.name) && 
            list.name.includes(projectName.trim())
          );
          console.log('🎯 Found by name pattern:', targetList);
        }
        
        // If still not found, get the most recent one as fallback
        if (!targetList) {
          const sortedLists = [...currentLists].sort((a, b) => {
            const timeA = new Date(a.lastModified || a.createdAt).getTime();
            const timeB = new Date(b.lastModified || b.createdAt).getTime();
            return timeB - timeA;
          });
          targetList = sortedLists[0];
          console.log('🎯 Using most recent as fallback:', targetList);
        }
        
        if (targetList) {
         console.log('✅ Target list found:', targetList.name, targetList.id);
          console.log('📦 Target list has products:', targetList.products?.length || 0);
          
          // Update the target list
          const updatedLists = currentLists.map(list => {
            if (list.id === targetList.id) {
              const updatedList= {
                ...list,
                mailSent: true,
                mailSentRevisionKey: generateRevisionKey(),
                lastModified: new Date().toISOString(),
                revisionKey: generateRevisionKey(),
                version: (list.version || 0) + 1
              };
              console.log('🔄 Updated list has products:', updatedList.products?.length || 0);
              return updatedList;
            }
            return list;
          });
          console.log('📋 Final updated lists count:', updatedLists.length);
          console.log('📋 All list names:', updatedLists.map(l => l.name));
          // Save and update state
          try {
            saveListsToStorage(updatedLists);
            console.log('✅ Successfully saved to localStorage');
          } catch (error) {
            console.error('❌ Error saving to localStorage:', error);
            throw error;
          }
          
            setLists(updatedLists);
          console.log('✅ List successfully updated with mailSent: true');

          // // Force state refresh after a short delay
          // setTimeout(() => {
          //   const verificationLists = JSON.parse(localStorage.getItem('savedProductLists') || '[]');
          //   setLists(verificationLists);
          //   console.log('🔄 Force refreshed state with', verificationLists.length, 'lists');
          // }, 100);

         
          
          // Verify the update
          const verifyLists = JSON.parse(localStorage.getItem('savedProductLists') || '[]');
          const updatedList = verifyLists.find(list => list.id === targetList.id);
          console.log('🔍 Verification - Updated list:', updatedList);

           setLists(prevLists => {
          console.log('🔄 Previous state:', prevLists.length, 'lists');
          console.log('🔄 New state:', updatedLists.length, 'lists');
          return [...updatedLists]; // Create new array reference
             });

          //Final verification
          const finalVerification = JSON.parse(localStorage.getItem('savedProductLists') || '[]');
          const verifiedList = finalVerification.find(list => list.id === targetList.id);
          console.log('🔍 Final Verification:');
          console.log('  - Total lists in storage:', finalVerification.length);
          console.log('  - Target list mailSent:', verifiedList?.mailSent);
          console.log('  - Target list products:', verifiedList?.products?.length || 0);
          
          if (finalVerification.length !== currentLists.length) {
            console.error('❌ CRITICAL: List count mismatch after save!');
            console.log('Expected:', currentLists.length, 'Got:', finalVerification.length);
          }
          
        } else {
          console.error('❌ No suitable list found to update');
        }
      }
      
      setShowMailModal(false);
      refreshAllListStates();

    } else {
      // Handle validation errors from PHP
      console.error('❌ API Errors:', result.errors);
      let errorMessage = 'Failed to send quote:\n';
      if (result.errors) {
        Object.entries(result.errors).forEach(([field, error]) => {
          errorMessage += `• ${field}: ${error}\n`;
        });
      } else {
        errorMessage += result.message || 'Unknown error occurred.';
      }
      showError(errorMessage);
    }
    
  } catch (error) {
    console.error('❌ Error sending mail:', error);
    showError(`Failed to send quote: ${error.message}. Please check your connection and try again.`);
  } finally {
    setIsSendingMail(false);
  }
};

/* All or mail block end */

  const dropdownRefs = useRef({});
  const customerDropdownRef = useRef(null);
  const syncIntervalRef = useRef(null);
  const SYNC_INTERVAL = 300000; // 5 minutes
  
  const getConnectionStatus = () => {
    if (isLoading) return 'connecting';
    if (!isOnline) return 'offline';
    if (syncError) return 'failed';
    return 'connected';
  };

  const getFilteredCustomers = (searchTerm) => {
    // if (!searchTerm) return customers;
    // if (!searchTerm.trim()) {
    if (!searchTerm || !searchTerm.trim()) {
      return customers.slice(0, 10); // Show first 10 customers when empty
    }

    // Ensure customers array exists
      if (!Array.isArray(customers)) {
        return [];
      }

    return customers.filter(customer => {
      // Skip if customer is null/undefined
    if (!customer) return false;

    // Safely handle potentially undefined/null values
    // const name = customer.name?.toLowerCase() || '';
    // const email = customer.email?.toLowerCase() || '';
    // const contactPerson = customer.contactPerson?.toLowerCase() || '';

    const name = (customer.name || '').toString().toLowerCase();
    const email = (customer.email || '').toString().toLowerCase();
    const contactPerson = (customer.contactPerson || '').toString().toLowerCase();
    
    // const searchTermLower = searchTerm.toLowerCase();
    const searchTermLower = searchTerm.toLowerCase().trim();
    
    return name.includes(searchTermLower) || 
           email.includes(searchTermLower) || 
           contactPerson.includes(searchTermLower);
  });
      
  };

  // const selectCustomer = (customer) => {
  //  if (!('address' in customer)) {
  //   customer.address = formatAddress(customer); // or use 'N/A' or null as needed
  // }
  //   setSelectedCustomer(customer);
  //    console.log("currently selected customer2");
  //   console.log(selectedCustomer);
  //   setCustomerSearchTerm(customer.name);
  //   setIsCustomerDropdownOpen(false);
  // };

const selectCustomer = (customer) => {
  console.log('Selecting customer:', customer);
  
  // Ensure the customer object has all required fields
  const customerToSelect = {
    ...customer,
    // Ensure address field exists
    address: customer.address || formatAddress(customer) || 'Address not available'
  };
  
  setSelectedCustomer(customerToSelect);
  setCustomerSearchTerm(customerToSelect.name);
  setIsCustomerDropdownOpen(false);
  
  console.log('Customer selected successfully:', customerToSelect.name);
};

  // Validation rules
  const validateField = (name, value) => {
    let error = '';
    
    switch (name) {
      case 'name':
        if (!value.trim()) {
          error = 'Customer name is required';
        } else if (value.trim().length < 2) {
          error = 'Customer name must be at least 2 characters';
        }
        break;
        
      case 'address':
        if (!value.trim()) {
          error = 'Address is required';
        } else if (value.trim().length < 5) {
          error = 'Address must be at least 5 characters';
        }
        break;
        
      case 'email':
        if (!value.trim()) {
          error = 'Email is required';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          error = 'Please enter a valid email address';
        }
        break;
        
      case 'contactNumber':
        if (!value.trim()) {
          error = 'Contact number is required';
        } else if (!/^[\+]?[(]?[\d\s\-\(\)]{10,}$/.test(value.replace(/\s/g, ''))) {
          error = 'Please enter a valid contact number (minimum 10 digits)';
        }
        break;
        
      case 'contactPerson':
        if (!value.trim()) {
          error = 'Contact person is required';
        } else if (value.trim().length < 2) {
          error = 'Contact person name must be at least 2 characters';
        }
        break;
        
      default:
        break;
    }
    
    return error;
  };

  // Validate all fields
  const validateAllFields = () => {
    const newErrors = {};
    const fields = ['name', 'address', 'email', 'contactNumber', 'contactPerson'];
    
    fields.forEach(field => {
      const error = validateField(field, newCustomer[field]);
      if (error) {
        newErrors[field] = error;
      }
    });
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  // Handle field changes
  const handleFieldChange = (field, value) => {
    setNewCustomer(prev => ({ ...prev, [field]: value }));
    
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  // Handle field blur (when user leaves the field)
  const handleFieldBlur = (field) => {
    setTouched(prev => ({ ...prev, [field]: true }));
    const error = validateField(field, newCustomer[field]);
    setErrors(prev => ({ ...prev, [field]: error }));
  };

  const handleCancel = () => {
    setShowAddCustomerForm(false);
    setNewCustomer({
      name: '',
      address: '',
      email: '',
      contactNumber: '',
      contactPerson: ''
    });
    setErrors({});
    setTouched({});
  };

  const handleAddNewCustomer = async () => {
    const allFields = ['name', 'address', 'email', 'contactNumber', 'contactPerson'];
    const newTouched = {};
    allFields.forEach(field => {
      newTouched[field] = true;
    });
    setTouched(newTouched);
    // if (!newCustomer.name || !newCustomer.address) {
    //   alert('Please fill in at least name and address');
    //   return;
    // }

    // Validate all fields
    if (!validateAllFields()) {
      return;
    }

    try {
    // More detailed customer data mapping
    const customerData = {
      name: newCustomer.name,
      street: newCustomer.address,
      email: newCustomer.email || false,
      phone: newCustomer.contactNumber || false,
      mobile: newCustomer.contactNumber || false, // Use same number for mobile
      is_company: true, // Change to false for individuals
      customer_rank: 1, // Mark as customer
      supplier_rank: 0, // Not a supplier
      category_id: [], // Customer categories if needed
      // If you have more address fields, map them:
      // street2: newCustomer.address2 || false,
      // city: newCustomer.city || false,
      // zip: newCustomer.zip || false,
      // state_id: newCustomer.stateId || false,
      // country_id: newCustomer.countryId || false,
    };

    // Add contact person as a child contact if provided
    if (newCustomer.contactPerson) {
      // You might want to handle contact person differently
      customerData.comment = `Contact Person: ${newCustomer.contactPerson}`;
    }
    customerData.quote_creator_id=userId;
    console.log('Creating new customer in Odoo...');
    
    const newCustomerId = await odooService.create('res.partner', customerData);
    
    console.log(`✅ Successfully created customer with ID: ${newCustomerId}`);

    // Optionally, fetch the created customer to get all fields
    const createdCustomer = await odooService.read('res.partner', [newCustomerId], [
      'id', 'name', 'email', 'phone', 'street', 'city', 'zip'
    ]);
    const customer = {
      id: newCustomerId,
      name: newCustomer.name,
      address: newCustomer.address,
      email: newCustomer.email,
      contactNumber: newCustomer.contactNumber,
      contactPerson: newCustomer.contactPerson
    };

    // const customer = {
    //   id: customers.length + 1,
    //   ...newCustomer
    // };

    setCustomers([...customers, customer]);
    setSelectedCustomer(customer);
    setCustomerSearchTerm(customer.name);
    setNewCustomer({
      name: '',
      address: '',
      email: '',
      contactNumber: '',
      contactPerson: ''
    });
    setErrors({});
      setTouched({});
    setShowAddCustomerForm(false);
    // alert(`Customer "${customer.name}" created successfully!`);
    showSuccess(`Customer "${customer.name}" created successfully!`);
    // console.log('Triggering manual sync after customer creation...');
      handleManualSync(); // Uncomment this line when integrating with your actual code
    } catch (error) {
    console.error('Failed to create customer in Odoo:', error);
    
    // Handle specific Odoo errors
    if (error.message.includes('duplicate')) {
      // alert('A customer with this information already exists.');
      showError('A customer with this information already exists.');
    } else if (error.message.includes('required')) {
      // alert('Please fill in all required fields.');
      showError('Please fill in all required fields.');
    } else {
      // alert(`Failed to create customer: ${error.message}`);
      showError(`Failed to create customer: ${error.message}`);
    }
  }
  };

  // Memory storage functions (no localStorage usage)
  const memoryStorage = {};  /// but we didnt use it 

//   const getFromStorage = (key) => {
//     return memoryStorage[key] || null;
//   };

const getFromStorage = (key) => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error('Error reading from localStorage:', error);
      return null;
    }
  };

//   const saveToStorage = (key, data) => {
//     memoryStorage[key] = data;
//   };

const generateUniqueKey = () => {
    return `list_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  };
  const generateRowUniqueKey = (row, index) => {
    if (row.id) return row.id;
    if (row.uuid) return row.uuid;
    // Create a unique key based on row content or index
    //return `row-${index}-${JSON.stringify(row).slice(0, 20)}-${Math.random()}`;
    return `row-${index}-${Math.random().toString(36).slice(2, 11)}`;
};
const generateUniqueId = () => {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};
  // Generate revision key
  const generateRevisionKey = () => {
    return `rev_${Date.now()}_${Math.random().toString(36).substr(2, 6)}`;
  };

// const saveToStorage = (key, data) => {
//     try {
//       localStorage.setItem(key, JSON.stringify(data));
//       console.log(`Saved ${key} to localStorage`);
//     } catch (error) {
//       console.error('Error saving to localStorage:', error);


//     }
//   };

const saveToStorage = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
    console.log(`Saved ${key} to localStorage`);
  } catch (error) {
    console.error('Error saving to localStorage:', error);
    
    if (error.name === 'QuotaExceededError') {
      console.warn(`Storage quota exceeded for ${key}. Attempting to save essential data only...`);
      
      // Handle different data types with customized reduction strategies
      let essentialData;
      
      if (key === 'savedProductLists' && Array.isArray(data)) {
        // For product lists - reduce to essential fields only
        essentialData = data.map(list => ({
          id: list.id,
          name: list.name,
          customer: list.customer ? {
            id: list.customer.id,
            name: list.customer.name,
            email: list.customer.email,
            address: list.customer.address
          } : null,
          project: list.project || '',
          notesInfo: list.notesInfo || '',
          products: (list.products || []).map(p => ({
            product: {
              id: p.product?.id,
              name: p.product?.name,
              price: p.product?.price
            },
            quantity: p.quantity
          })),
          createdAt: list.createdAt,
          itemCount: list.itemCount || 0
        }));
      } else if (key === 'customers' && Array.isArray(data)) {
        // For customers - keep only essential customer fields
        essentialData = data.map(customer => ({
          id: customer.id,
          name: customer.name,
          email: customer.email || '',
          phone: customer.phone || customer.mobile || customer.contactNumber || '',
          address: customer.address || '',
          contactPerson: customer.contactPerson || customer.contact_person || ''
        }));
      } else if (key === 'odooProducts' && Array.isArray(data)) {
        // For products - keep only essential product fields
        essentialData = data.map(product => ({
          id: product.id,
          name: product.name,
          price: product.price || 0,
          category: product.category || 'Uncategorized',
          code: product.code || ''
        }));
      } else {
        // For other data types, try to reduce by keeping only essential fields
        if (typeof data === 'object' && data !== null) {
          essentialData = { ...data };
          // Remove potentially large fields
          delete essentialData.description;
          delete essentialData.metadata;
          delete essentialData.extraInfo;
        } else {
          essentialData = data;
        }
      }
      
      try {
        localStorage.setItem(key, JSON.stringify(essentialData));
        console.log(`Saved essential ${key} data successfully`);
      } catch (stillError) {
        console.warn(`Still failing to save ${key}, trying further reduction...`);
        
        // Further reduction based on data type
        let minimalData;
        
        if (key === 'savedProductLists' && Array.isArray(essentialData)) {
          // Keep only last 10 lists with minimal data
          minimalData = essentialData.slice(-10).map(list => ({
            id: list.id,
            name: list.name,
            customer: list.customer ? {
              id: list.customer.id,
              name: list.customer.name
            } : null,
            project: list.project || '',
            itemCount: list.itemCount || 0,
            createdAt: list.createdAt
          }));
        } else if (key === 'customers' && Array.isArray(essentialData)) {
          // Keep only last 50 customers with minimal data
          minimalData = essentialData.slice(-50).map(customer => ({
            id: customer.id,
            name: customer.name,
            email: customer.email || ''
          }));
        } else if (key === 'odooProducts' && Array.isArray(essentialData)) {
          // Keep only last 100 products with minimal data
          minimalData = essentialData.slice(-100).map(product => ({
            id: product.id,
            name: product.name,
            price: product.price || 0
          }));
        } else {
          minimalData = essentialData;
        }
        
        try {
          localStorage.setItem(key, JSON.stringify(minimalData));
          console.warn(`Saved minimal ${key} data due to storage limits`);
          
          // Show user notification about data reduction
          if (typeof showError === 'function') {
            showError(`Storage space low. Some ${key.replace(/([A-Z])/g, ' $1').toLowerCase()} data was reduced to fit.`);
          }
        } catch (finalError) {
          console.error(`Failed to save even minimal ${key} data:`, finalError);
          
          // Last resort - clear some old data and try again
          try {
            // Clear old cache data to make space
            const keysToClean = ['tempData', 'cache', 'logs'];
            keysToClean.forEach(cleanKey => {
              if (localStorage.getItem(cleanKey)) {
                localStorage.removeItem(cleanKey);
                console.log(`Cleared ${cleanKey} to make space`);
              }
            });
            
            // Try saving minimal data again
            localStorage.setItem(key, JSON.stringify(minimalData));
            console.log(`Successfully saved ${key} after cleanup`);
            
            if (typeof showWarning === 'function') {
              // showWarning(`Storage cleaned up to save ${key} data. Some old data was removed.`);
              showInfo(`Storage cleaned up to save ${key} data. Some old data was removed.`);
            }
          } catch (ultimateError) {
            console.error(`Ultimate failure to save ${key}:`, ultimateError);
            
            if (typeof showError === 'function') {
              // showError(`Unable to save ${key} data. Storage is full. Please clear browser data.`);
              showInfo(`Unable to save ${key} data. Storage is full. Please clear browser data.`);
            }
            
            throw new Error(`Unable to save ${key} due to storage limitations`);
          }
        }
      }
    } else {
      // For non-quota errors, just log and re-throw
      console.error(`Non-quota error saving ${key}:`, error);
      
      if (typeof showError === 'function') {
        showError(`Failed to save ${key}: ${error.message}`);
      }
      
      throw error;
    }
  }
};

  const getSavedLists = () => {
    return getFromStorage('savedProductLists') || [];
  };

  const saveListsToStorage = (lists) => {
    saveToStorage('savedProductLists', lists);
  };

  // Test Odoo connection
//   const testConnection = async () => {
//     try {
//       setIsLoading(true);
//       setSyncError(null);
      
//     //   const result = await testConnection();
//      await odooService.getVersion();
//       const uid=await odooService.login();
//       if (uid) {

//          //result.success=true
//          setResult({ status: 'success', error: null });
//         setConnectionStatus('connected');
//         console.log('Connection successful:', result.status);
//         fetchProducts();
//       } else {
//         setConnectionStatus('failed');
//         setSyncError(`Connection failed: ${result.error}`);
//       }
      
//       return result;
//     } catch (error) {
//       setConnectionStatus('failed');
//       setSyncError(`Connection error: ${error.message}`);
//       console.error('Connection test error:', error);
//       return { success: false, error: error.message };
//     } finally {
//       setIsLoading(false);
//     }
//   };

const loadCachedProducts = () => {
          //  console.log('Attempting to load cached products...');
    const cachedProducts = getFromStorage('odooProducts');
    
    if (cachedProducts && Array.isArray(cachedProducts) && cachedProducts.length > 0) {
      setProducts(cachedProducts);
        // console.log(`✅ Loaded ${cachedProducts.length} products from localStorage cache`);
      
      // Also load last sync time
      const cachedLastSync = getFromStorage('lastSync');
      if (cachedLastSync) {
        setLastSync(new Date(cachedLastSync));
              // console.log(`Last sync was: ${cachedLastSync}`);
      }
      
      return true;
    } else {
      console.log('❌ No cached products found in localStorage');
      return false;
    }
  };


const testConnection = async () => {
  // If offline, immediately load cached products
            // console.log(`logged user id is ${userId}`);
            // console.log(`🔍 Testing connection... Online status: ${navigator.onLine}`);
  if (!navigator.onLine) {
    console.log('Device is offline, loading cached products');
    const hasProductCache = loadCachedProducts();
    const hasCustomerCache = loadCachedCustomers();
    // if (hasCache) {
    if (hasProductCache || hasCustomerCache) {
      setConnectionStatus('offline');
      setSyncError('Offline mode - using cached data');
      return { success: false, error: 'Offline mode - using cached data', hasProductCache,hasCustomerCache };

    } else {
      setConnectionStatus('offline');
      setSyncError('No cached products available offline');
      return { success: false, error: 'No cached data available offline',hasProductCache: false,hasCustomerCache: false };
    }
  }

  try {
    setIsLoading(true);
    setSyncError(null);
    
    await odooService.getVersion();
    const uid = await odooService.login();
    
    if (uid) {
      setResult({ status: 'success', error: null });
      setConnectionStatus('connected');
        // console.log('Connection successful');
      // Load both products and customers when connected
      await Promise.all([
        // loadProductsFromOdoo(),
        fetchProducts(),
        //loadCustomersFromOdoo()
        fetchCustomers(),
      ]);
      return { success: true };
    } else {
      setConnectionStatus('failed');
      setSyncError('Connection failed: Unable to login');
      // Try to load cached products as fallback
    //   loadCachedProducts();
        const hasProductCache = loadCachedProducts();
      const hasCustomerCache = loadCachedCustomers();
      return { success: false, error: 'Connection failed',hasProductCache,hasCustomerCache };
    }
  } catch (error) {
    setConnectionStatus('failed');
    setSyncError(`Connection error: ${error.message}`);
    console.error('Connection test error:', error);
    
    // Try to load cached products as fallback
   const hasProductCache = loadCachedProducts();
    const hasCustomerCache = loadCachedCustomers();
    
    if (hasProductCache || hasCustomerCache) {
      console.log('Using cached data due to connection error');
    }
        
    return { 
      success: false, 
      error: error.message,
      hasProductCache,
      hasCustomerCache
    };
  } finally {
    setIsLoading(false);
  }
};

const loadCustomersFromOdoo = async () => {
  try {
    // console.log('🔄 Loading customers from Odoo...');
    setIsLoading(true);
    
    // Fetch customers from Odoo (adjust fields based on your Odoo model)
    const customerData = await odooService.searchRead('res.partner', [], [
      'name',
      'email', 
      'phone',
      'mobile',
      'street',
      'street2',
      'city',
      'state_id',
      'country_id',
      'zip',
      'is_company',
      'customer_rank'
    ]);
    
    // Filter only customers (not suppliers)
    const customers = customerData
      .filter(partner => partner.customer_rank > 0)
      .map(partner => ({
        id: partner.id,
        name: partner.name,
        email: partner.email || '',
        phone: partner.phone || partner.mobile || '',
        address: formatAddress(partner),
        contactPerson: partner.is_company ? '' : partner.name,
        createdAt: new Date().toISOString(),
        syncedAt: new Date().toISOString()
      }));
    
    // console.log(`✅ Loaded ${customers.length} customers from Odoo`);
    
    // Update state
    setCustomers(customers);
    
    // Cache customers
    cacheCustomers(customers);
    // console.log(customers);
    return customers;
  } catch (error) {
    console.error('❌ Error loading customers from Odoo:', error);
    setSyncError(`Failed to load customers: ${error.message}`);
    
    // Fallback to cached customers
    const hasCache = loadCachedCustomers();
    if (hasCache) {
      console.log('Using cached customers due to Odoo error');
    }
    
    throw error;
  } finally {
    setIsLoading(false);
  }
};

// Format address from Odoo partner data
const formatAddress = (partner) => {
  if (!partner) return '';
  
  const addressParts = [
    partner.street || '',
    partner.street2 || '',
    partner.city || '',
    partner.state_id ? (Array.isArray(partner.state_id) ? partner.state_id[1] : partner.state_id) : '',
    partner.country_id ? (Array.isArray(partner.country_id) ? partner.country_id[1] : partner.country_id) : '',
    partner.zip || ''
  ].filter(part => part && part.trim() !== '');
  
  return addressParts.length > 0 ? addressParts.join(', ') : 'Address not available';
};

// Cache customers to localStorage
const cacheCustomers = (customersList) => {
  try {
    const cacheData = {
      customers: customersList,
      timestamp: new Date().toISOString()
    };
    // saveToStorage('customers', cacheData);
    saveCustomersToStorage(cacheData)
           // console.log('✅ Customers cached successfully');
  } catch (error) {
    console.error('❌ Error caching customers:', error);
  }
};

// Load cached customers
const loadCachedCustomers = () => {
  try {
    // const cached = localStorage.getItem('customers_cache');
    const cached = getFromStorage('customers');
    if (cached) {
      const cacheData = JSON.parse(cached);
      const customers = cacheData.customers || [];
      
          // console.log(`📦 Loaded ${customers.length} cached customers`);
      setCustomers(customers);
      
      // Show cache info
      const cacheAge = new Date(cacheData.timestamp);
            // console.log(`Cache timestamp: ${cacheAge.toLocaleString()}`);
      
      return true;
    }
    return false;
  } catch (error) {
    console.error('❌ Error loading cached customers:', error);
    return false;
  }
};


//   const loadCachedProducts = () => {
//   const cachedProducts = getFromStorage('odooProducts');
//   if (cachedProducts && cachedProducts.length > 0) {
//     setProducts(cachedProducts);
//     setConnectionStatus('offline');
//     console.log(`Loaded ${cachedProducts.length} products from cache (offline mode)`);
//     return true;
//   }
//   return false;
// };


  // Fetch products using the data service
//   const fetchProducts = async () => {
    
//     try {
//         let transformedProducts = [];
//       setIsLoading(true);
//       setSyncError(null);

//       console.log('Fetching products from Odoo...');
      
//     //   // Use the fetchProductsFromOdoo function from your data service
//     //   const transformedProducts = await fetchProductsFromOdoo();
      
//     //   console.log(`Successfully fetched ${transformedProducts.length} products`);
      
//     //   setProducts(transformedProducts);

//     const uid = await odooService.login();
//         if (uid) {
//             console.log("receievde uid......")
       
//         setConnectionStatus('connected');
//         console.log('Connection successful:');
//         setConnectionStatus('connected');
//         const productsData = await odooService.fetchProducts();
       
//         // setProducts(transformedProducts);
//             const transformedProducts = Array.isArray(productsData) ? productsData.map(product => ({
//         id: product.id || product.product_id,
//         name: product.name || product.product_name || product.display_name,
//         price: product.price || product.list_price || product.standard_price || 0,
//         category: product.category || product.categ_id[1] || product.category_name || 'Uncategorized',
//         code: product.code || product.default_code || product.internal_reference || '',
//         barcode: product.barcode || '',
//         odooId: product.id || product.product_id
//       })) : [];
//              // Save to memory storage
//             //  console.log(productsData);
//         saveToStorage('odooProducts', transformedProducts);
//         saveToStorage('lastSync', new Date().toISOString());
//             setProducts(transformedProducts);
//              setLastSync(new Date());
//         }
      
//     } catch (error) {
//       console.error('Error fetching products:', error);
//       setSyncError(error.message);
//       setConnectionStatus('failed');
      
//       // Load from memory storage as fallback
//       const cachedProducts = getFromStorage('odooProducts');
//       if (cachedProducts && cachedProducts.length > 0) {
//         setProducts(cachedProducts);
//         console.log('Loaded products from cache');
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   };

const fetchProducts = async () => {
  // If offline, load from cache
          //  console.log(`🔄 Fetch products called... Online: ${navigator.onLine}`);
  if (!navigator.onLine) {
    console.log('Device offline, loading cached products');
    const hasCache = loadCachedProducts();
      if (!hasCache) {
        setSyncError('Device offline and no cached products available');
      }
      return;
  }

  try {
    setIsLoading(true);
    setSyncError(null);

          // console.log('Fetching products from Odoo...');

    const uid = await odooService.login();
    if (uid) {
            // console.log("Received uid, fetching products...");
      
      setConnectionStatus('connected');
      // const productsData = await odooService.fetchProducts();
      const productsData = await odooService.fetchProductsByCategories();
      
      const transformedProducts = Array.isArray(productsData) ? productsData.map(product => ({
        id: product.id || product.product_id,
        name: product.name || product.product_name || product.display_name,
        price: product.price || product.list_price || product.standard_price || 0,
        category: product.category || product.categ_id[1] || product.category_name || 'Uncategorized',
        code: product.code || product.default_code || product.internal_reference || '',
        barcode: product.barcode || '',
        odooId: product.id || product.product_id
      })) : [];
      
      // Save to cache
      saveToStorage('odooProducts', transformedProducts);
      saveToStorage('lastSync', new Date().toISOString());
      
      setProducts(transformedProducts);
      setLastSync(new Date());
      
      // console.log(`Successfully fetched and cachedDDDDDDDDDDDDDDDD ${transformedProducts.length} products`);
    }
  } catch (error) {
    console.error('Error fetching products:', error);
    setSyncError(error.message);
    setConnectionStatus('failed');
    
    // Load from cache as fallback
    const hasCache = loadCachedProducts();
    if (hasCache) {
      console.log('Fallback to cached products due to fetch error');
    } else {
      console.log('No cached products available');
    }
  } finally {
    setIsLoading(false);
  }
};

  const fetchCustomers= async () => {
    if (!navigator.onLine) {
      console.log('Device offline, loading cached products');
      const hascustCache1 = loadCachedCustomers();
        if (!hascustCache1) {
          setSyncError('Device offline and no cached products available');
        }
        return;
    }
        try {
        setIsLoading(true);
        setSyncError(null);

              // console.log('Fetching customers from Odoo...');

        const uid = await odooService.login();
        if (uid) {
                  // console.log("Received uid, fetching customers...");
      
      setConnectionStatus('connected');
      const customersData = await odooService.fetchCustomers();
      
      const transformedCustomers = Array.isArray(customersData) ? customersData.map(customer => ({
        id: customer.id || 1000001,
        name: customer.name || ' ',
        email: customer.email || '',
        phone: customer.phone || '',
        mobile: customer.mobile || '',
        street: customer.street || '',
        street2: customer.street2 || '',
        city: customer.city || '',
        state_id: customer.state_id || '',
        country_id: customer.country_id || '',
        zip: customer.zip || '' ,
        is_company: customer.is_company || '',
        customer_rank: customer.customer_rank || ''
      })) : [];
      
      // Save to cache
      saveCustomersToStorage(transformedCustomers);
      //saveToStorage('lastSync', new Date().toISOString());
      
      setCustomers(transformedCustomers);
      setLastSync(new Date());
      
        // console.log(`Successfully fetched and cachedDDDDDDDDDDDDDDDD ${transformedCustomers.length} customers`);
    }
        }
        catch (error) {
        console.error('Error fetching Customers:', error);
            setSyncError(error.message);
            setConnectionStatus('failed');
        
        // Load from cache as fallback
        const hascustCache = loadCachedCustomers();
        if (hascustCache) {
          console.log('Fallback to cached customers due to fetch error');
        } else {
          console.log('No cached customers available');
        }
      } finally {
        setIsLoading(false);
      }


  }

  // Fetch categories using the data service
//   const fetchCategories = async () => {
//     try {
//       const categoriesData = await fetchProductCategories();
//       setCategories(categoriesData);
//       saveToStorage('productCategories', categoriesData);
//     } catch (error) {
//       console.error('Error fetching categories:', error);
//       // Load from cache if available
//       const cachedCategories = getFromStorage('productCategories');
//       if (cachedCategories) {
//         setCategories(cachedCategories);
//       }
//     }
//   };


useEffect(() => {
  if (result.status === 'success') {
    console.log('Connection successful:', result.status);
  }
}, [result.status]);

  // Load cached data and perform initial sync
//   useEffect(() => {
//     const cachedProducts = getFromStorage('odooProducts');
//     const cachedCategories = getFromStorage('productCategories');
//     const cachedLastSync = getFromStorage('lastSync');
//     const saved = getSavedLists();
    
//     if (cachedProducts) {
//       setProducts(cachedProducts);
//       console.log(`Loaded ${cachedProducts.length} products from cache`);
//     }
    
//     if (cachedCategories) {
//       setCategories(cachedCategories);
//     }
    
//     if (cachedLastSync) {
//       setLastSync(new Date(cachedLastSync));
//     }
    
//     setSavedLists(saved);
    
//     // Initial connection test and data fetch
//     if (navigator.onLine) {
//       testConnection().then(result => {
//         if (result.success) {
//             console.log("calling product suc ...............")
//           fetchProducts();
//         //   fetchCategories();
//         }
//       });
//     }
//   }, []);

  // Set up auto-sync
  
  useEffect(() => {
    //  console.log('🚀 App initializing...');
    // console.log(`📱 Initial online status: ${navigator.onLine}`);
    
    // Always try to load cached data first
    // console.log('📦 Loading cached data...');
  const cachedProducts = getFromStorage('odooProducts');
  const cachedCategories = getFromStorage('productCategories');
  const cachedLastSync = getFromStorage('lastSync');
  const saved = getSavedLists();
  
  // Always load cached data first
  if (cachedProducts && cachedProducts.length > 0) {
    setProducts(cachedProducts);
    //  console.log(`Loaded ${cachedProducts.length} products from cache`);
  }
  
  if (cachedCategories) {
    setCategories(cachedCategories);
  }
  
  if (cachedLastSync) {
    setLastSync(new Date(cachedLastSync));
  }
  
  setSavedLists(saved);
  
  // Test connection and fetch fresh data if online
  if (navigator.onLine) {
    testConnection().then(result => {
      if (result.success) {
        // console.log("Connection successful, fetching fresh products...");
        fetchProducts();
        //loadCustomersFromOdoo(); 
        fetchCustomers();
      } else {
        // console.log("Connection failed, using cached products");
        if (!cachedProducts) {
            // console.log("⚠️ No cached products and connection failed");
            setSyncError('Device offline and no cached products available');
          }
      }
    });
  } else {
    // If offline from start, set status and use cached data
    console.log("Starting in offline mode");
    setConnectionStatus('offline');
    setIsOnline(false);
  }
}, []);
  
//   useEffect(() => {
//     if (autoSync && isOnline && connectionStatus === 'connected') {
//       syncIntervalRef.current = setInterval(() => {
//         fetchProducts();
//       }, SYNC_INTERVAL);
//     } else if (syncIntervalRef.current) {
//       clearInterval(syncIntervalRef.current);
//     }

//     return () => {
//       if (syncIntervalRef.current) {
//         clearInterval(syncIntervalRef.current);
//       }
//     };

useEffect(() => {
  const handleOnline = () => {
    console.log('Device came online');
    setIsOnline(true);
    setSyncError(null);
    if (autoSync) {
      testConnection().then(result => {
        if (result.success) {
          fetchProducts(); // Fetch fresh data when coming online
          fetchCustomers();
        }
      });
    }
  };
  const handleOffline = () => {
    console.log('Device went offline');
    setIsOnline(false);
    setConnectionStatus('offline');
    // Products already loaded from cache, no need to reload
    const hasCache = loadCachedProducts();
      if (hasCache) {
              // console.log('📦 Switched to cached products (offline mode)');
        setSyncError('Device offline - using cached data');
      } else {
        console.log('❌ No cached products available offline');
        setSyncError('Device offline and no cached products available');
      }
  };

  window.addEventListener('online', handleOnline);
  window.addEventListener('offline', handleOffline);

  return () => {
    window.removeEventListener('online', handleOnline);
    window.removeEventListener('offline', handleOffline);
  };
}, [autoSync]);

  // Monitor online/offline status
//   useEffect(() => {
//     const handleOnline = () => {
//       setIsOnline(true);
//       if (autoSync && connectionStatus !== 'failed') {
//         testConnection().then(result => {
//           if (result.success) {
//             fetchProducts();
//           }
//         });
//       }
//     };

//     // const handleOffline = () => {
//     //   setIsOnline(false);
//     //   setConnectionStatus('offline');
//     // };

//     window.addEventListener('online', handleOnline);
//     window.addEventListener('offline', handleOffline);

//     return () => {
//       window.removeEventListener('online', handleOnline);
//       window.removeEventListener('offline', handleOffline);
//     };
//   }, [autoSync, connectionStatus]);


// const handleManualSync = async () => {
//   if (!navigator.onLine) {
//     console.log('Manual sync requested but device is offline, using cached data');
//     const hasCache = loadCachedProducts();
//     if (!hasCache) {
//       setSyncError('No cached products available offline');
//     }
//     return;
//   }

//   const connectionResult = await testConnection();
//   if (connectionResult.success) {
//     await fetchProducts();
//   }
// };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      Object.keys(dropdownRefs.current).forEach(rowId => {
        if (dropdownRefs.current[rowId] && !dropdownRefs.current[rowId].contains(event.target)) {
          setRows(prevRows => prevRows.map(row => 
            row.id === parseInt(rowId) ? { ...row, isDropdownOpen: false } : row
          ));
        }
      });
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Manual sync function
//   const handleManualSync = async () => {
//     if (isOnline) {
//       const connectionResult = await testConnection();
//       if (connectionResult.success) {
//         await fetchProducts();
//       }
//     }
//   };

const handleManualSync = async () => {
    // console.log('🔄 Manual sync requested...');
    
    if (!navigator.onLine) {
            // console.log('📱 Manual sync requested but device is offline');
      const hasCache = loadCachedProducts();
      if (!hasCache) {
        setSyncError('No cached products available offline');
              // console.log('❌ No cached data for offline use');
      } else {
        setSyncError('Device offline - using cached data');
        console.log('📦 Using cached products (offline manual sync)');
      }
      return;
    }

          // console.log('🌐 Manual sync: Testing connection...');
    const connectionResult = await testConnection();
    if (connectionResult.success) {
              // console.log('✅ Manual sync: Connection successful, fetching products...');
      await fetchProducts();
      await fetchCustomers();
    } else {
      console.log('❌ Manual sync: Connection failed');
    }
  };

  // Add new row
  const addRow = () => {
    const newRow = {
      id: rowIdCounter,
      selectedProduct: null,
      quantity: 1,
      searchTerm: '',
      isDropdownOpen: false
    };
    setRows([...rows, newRow]);
    setRowIdCounter(rowIdCounter + 1);
  };

  // Remove row
  const removeRow = (rowId) => {
    if (rows.length > 1) {
      setRows(rows.filter(row => row.id !== rowId));
      delete dropdownRefs.current[rowId];
    }
  };

  // Update row data
  const updateRow = (rowId, updates) => {
    setRows(rows.map(row => 
      row.id === rowId ? { ...row, ...updates } : row
    ));
  };

  // Handle product selection
  const selectProduct = (rowId, product) => {
    updateRow(rowId, {
      selectedProduct: product,
      searchTerm: product.name,
      isDropdownOpen: false
    });
  };

  // Filter products for a specific row
  const getFilteredProducts = (searchTerm) => {
    if (!searchTerm.trim()) {
      return products.slice(0, 10); // Show first 10 products when empty
    }
    
    return products.filter(product =>
      product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (product.code && product.code.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (product.sku && product.sku.toLowerCase().includes(searchTerm.toLowerCase()))
    ).slice(0, 20); // Limit to 20 results
  };

  // Calculate total for a row
  const getRowTotal = (row) => {
    return row.selectedProduct ? row.selectedProduct.price * row.quantity : 0;
  };

  // Calculate grand total
  const grandTotal = rows.reduce((sum, row) => sum + getRowTotal(row), 0);

  // Get valid selected products (rows with products and quantities)
  const getValidProducts = () => {
    return rows
      .filter(row => row.selectedProduct && row.quantity > 0)
      .map(row => ({
        product: row.selectedProduct,
        quantity: row.quantity,
        total: getRowTotal(row)
      }));
  };

  // Save current selection
  const saveCurrentList = () => {
    const validProducts = getValidProducts();
    if (validProducts.length === 0) {
      // alert('Please select at least one product before saving!');
      showError('Please select at least one product before saving!');
      return;
    }
    setShowSaveModal(true);
  };

  // Handle save with name
  const handleSaveList = () => {
    if (!listName.trim()) {
      //alert('Please enter a name for your list!');
      showError('Please enter a name for your list!');
      return;
    }

    // Check if customer is selected, if not show new customer form
  if (!selectedCustomer || !selectedCustomer.id) {
    //alert('Please select a customer or add a new customer before saving!');
    showError('Please select a customer or add a new customer before saving!');
    // setShowNewCustomerForm(true);
    setShowAddCustomerForm(true);
    return;
  }

  if (!projectName.trim()) {
    //alert('Please enter a project name!');
     showError('Please enter a project name!');
    return;
  }

  const customerToSave = {
    id: selectedCustomer.id,
    name: selectedCustomer.name || '',
    email: selectedCustomer.email || '',
    phone: selectedCustomer.phone || selectedCustomer.mobile || selectedCustomer.contactNumber || '',
    mobile: selectedCustomer.mobile || selectedCustomer.phone || selectedCustomer.contactNumber || '',
    address: selectedCustomer.address || formatAddress(selectedCustomer) || '',
    contactPerson: selectedCustomer.contactPerson || selectedCustomer.contact_person || '',
    contactNumber: selectedCustomer.contactNumber || selectedCustomer.phone || selectedCustomer.mobile || '',
    // Additional Odoo fields that might be useful
    street: selectedCustomer.street || '',
    street2: selectedCustomer.street2 || '',
    city: selectedCustomer.city || '',
    state_id: selectedCustomer.state_id || '',
    country_id: selectedCustomer.country_id || '',
    zip: selectedCustomer.zip || '',
    createdAt: selectedCustomer.createdAt || new Date().toISOString()
  };

  console.log('Saving customer data:', customerToSave);

    const validProducts = getValidProducts();
    const newList = {
      // id: Date.now(),
       id: generateUniqueKey(),
      name: listName.trim(),
      revisionKey: generateRevisionKey(),
      
      
      customer: customerToSave,
      project:projectName.trim(),
      notesInfo:notesInfo.trim(),
      products: validProducts,
      totalAmount: grandTotal,
      createdAt: new Date().toISOString(),
      lastModified: new Date().toISOString(),
      itemCount: validProducts.reduce((sum, p) => sum + p.quantity, 0),
      version: 1
    };

    const updatedLists = cleanSavedLists([...savedLists, newList]);
    setSavedLists(updatedLists);
    try {
        saveListsToStorage(updatedLists);
    } catch (error) {
    console.error('Error saving list to storage:', error);
    showError('Failed to save list to storage');
    return;
     }
    setShowSaveModal(false);
    setListName('');

    // ✅ Clear all rows (products)
  setRows([]);
  setRowIdCounter(1); // Reset counter

  // ✅ Clear customer selection
  setSelectedCustomer(null);
  setCustomerSearchTerm('');
  setIsCustomerDropdownOpen(false);
  setProjectName('');
  setNotesInfo('');

    // alert('List saved successfully!');
    // alert(`List saved successfully for customer: ${selectedCustomer.name}!`);
    showSuccess(`List saved successfully for customer: ${selectedCustomer.name}!`);
  };

const saveCustomersToStorage = (customersList) => {
  // For example: localStorage.setItem('customers', JSON.stringify(customersList));
  //saveToStorage('customers', customersList);
  try {
    localStorage.setItem('customers', JSON.stringify(customersList));
    } catch (error) {
    if (error.name === 'QuotaExceededError') {
      console.warn('Storage quota exceeded. Saving essential data only...');
      
      // Save only essential fields to reduce size
      const essentialData = customersList.map(customer => ({
        id: customer.id,
        name: customer.name,
        email: customer.email,
        contactPerson: customer.contactPerson,
        address: customer.address,
        contactNumber: customer.contactNumber
        // Remove any large/unnecessary fields
      }));
      
      try {
        localStorage.setItem('customers', JSON.stringify(essentialData));
      } catch (stillError) {
        // If still failing, save only recent customers
        const recentCustomers = essentialData.slice(-100); // Last 100 customers
        localStorage.setItem('customers', JSON.stringify(recentCustomers));
        console.warn('Saved only recent 100 customers due to storage limits');
      }
    } else {
      console.error('Error saving customers:', error);
    }
  }
  
};


  // Handle new customer creation and then save list
const handleNewCustomerAndSave = (newCustomerData) => {
  // First save the new customer
  const newCustomer = {
    id: Date.now(),
    name: newCustomerData.name,
    email: newCustomerData.email || '',
    phone: newCustomerData.phone || '',
    address: newCustomerData.address || '',
    createdAt: new Date().toISOString()
  };

  // Add to customers list
  const updatedCustomers = [...customers, newCustomer];
  setCustomers(updatedCustomers);
  saveCustomersToStorage(updatedCustomers);

  // Set as selected customer
  setSelectedCustomer(newCustomer);

  // Close new customer form
  setShowAddCustomerForm(false);

  // Now save the list with the new customer
  const validProducts = getValidProducts();
  const newList = {
    id: Date.now(),
    name: listName.trim(),
    customer: {
      id: newCustomer.id,
      name: newCustomer.name,
      email: newCustomer.email,
      phone: newCustomer.phone,
      address: newCustomer.address
    },
    project:projectName,
    notesInfo:notesInfo,
    products: validProducts,
    totalAmount: grandTotal,
    createdAt: new Date().toISOString(),
    itemCount: validProducts.reduce((sum, p) => sum + p.quantity, 0)
  };

  const updatedLists = [...savedLists, newList];
  setSavedLists(updatedLists);
  saveListsToStorage(updatedLists);
      
  setShowSaveModal(false);
  setListName('');
  // alert(`List saved successfully for new customer: ${newCustomer.name}!`);
  showSuccess(`List saved successfully for new customer: ${newCustomer.name}!`);
};

// Alternative approach - Save list and prompt for customer selection
const saveCurrentListWithCustomerCheck = () => {
  const validProducts = getValidProducts();
  if (validProducts.length === 0) {
    // alert('Please select at least one product before saving!');
    showError('Please select at least one product before saving!');
    return;
  }

  // If no customer selected, show customer selection/creation options
  if (!selectedCustomer || !selectedCustomer.id) {
    //setShowCustomerSelectionModal(true);
     setShowAddCustomerForm(true);
    return;
  }

  setShowSaveModal(true);
};


const loadCustomersFromStorage = () => {
  try {
    const stored = localStorage.getItem('customers');
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.error('Error loading customers from localStorage:', error);
    return [];
  }
};

const debugCustomerLoad = (savedList) => {
  console.log('=== CUSTOMER LOAD DEBUG ===');
  console.log('Saved list customer:', savedList.customer);
  console.log('Current customers array:', customers);
  console.log('Current selectedCustomer:', selectedCustomer);
  console.log('=========================');
};
const debugListStructure = () => {
  const lists = JSON.parse(localStorage.getItem('savedProductLists') || '[]');
  
  console.log('🔍 LIST STRUCTURE DEBUG:');
  console.log('📊 Total lists:', lists.length);
  
  lists.forEach((list, index) => {
    console.log(`\n📋 List ${index + 1}:`);
    console.log('  ID:', list.id);
    console.log('  Name:', list.name);
    console.log('  Mail Sent:', list.mailSent);
    console.log('  Keys:', Object.keys(list));
    
    if (list.data) {
      console.log('  📦 Data structure:');
      console.log('    Data keys:', Object.keys(list.data));
      console.log('    Customer:', list.data.customer?.name || 'Not found');
      console.log('    Project:', list.data.projectName || 'Not found');
      console.log('    Rows count:', list.data.rows?.length || 0);
      
      if (list.data.rows && list.data.rows.length > 0) {
        console.log('    First row:', {
          product: list.data.rows[0].selectedProduct?.name,
          quantity: list.data.rows[0].quantity
        });
      }
    } else {
      console.log('  ❌ No data object found');
    }
  });
  
  return lists;
};

// const loadListWithCustomerFix = (savedList) => {
//   // Debug the customer loading
//   debugCustomerLoad(savedList);
  
//   console.log('Starting loadList function...');
  
//   // Clear existing rows
//   setRows([]);
  
//   // Load products
//   const newRows = savedList.products.map((item, index) => ({
//     id: index + 1,
//     selectedProduct: item.product,
//     quantity: item.quantity,
//     searchTerm: item.product.name,
//     isDropdownOpen: false
//   }));
  
//   setRows(newRows);
//   setRowIdCounter(newRows.length + 1);
  
//   // Load customer information if it exists
//   if (savedList.customer) {
//     console.log('Customer data from saved list:', savedList.customer);
    
//     // Find existing customer
//     const existingCustomer = customers.find(customer => 
//       customer.id === savedList.customer.id || 
//       customer.name.toLowerCase() === savedList.customer.name.toLowerCase()
//     );
    
//     if (existingCustomer) {
//       console.log('Found existing customer:', existingCustomer);
      
//       // Set the selected customer
//       setSelectedCustomer(existingCustomer);
      
//       // IMPORTANT: Update the customer search term to show the customer name
//       setCustomerSearchTerm(existingCustomer.name);
      
//       // Close the customer dropdown
//       setIsCustomerDropdownOpen(false);
      
//     } else {
//       console.log('Customer not found, adding new customer...');
//       const newCustomer = {
//         id: savedList.customer.id || Date.now(),
//         name: savedList.customer.name || '',
//         email: savedList.customer.email || '',
//         phone: savedList.customer.phone || '',
//         address: savedList.customer.address || '',
//         contactPerson: savedList.customer.contactPerson || '',
//         createdAt: savedList.customer.createdAt || new Date().toISOString()
//       };
      
//       // Add to customers array
//       const updatedCustomers = [...customers, newCustomer];
//       setCustomers(updatedCustomers);
//       saveCustomersToStorage(updatedCustomers);
      
//       // Set as selected customer
//       setSelectedCustomer(newCustomer);
      
//       // IMPORTANT: Update the customer search term to show the new customer name
//       setCustomerSearchTerm(newCustomer.name);
      
//       // Close the customer dropdown
//       setIsCustomerDropdownOpen(false);

      
//       console.log('Added and selected new customer:', newCustomer);
//     }
//   } else {
//     // Clear customer selection
//     setSelectedCustomer(null);
//     setCustomerSearchTerm('');
//     setIsCustomerDropdownOpen(false);
//   }
//    if (savedList.project) {
//         setProjectName(savedList.project);
//    }
//    else
//    {
//       setProjectName('');
//    }
  
//   setShowLoadModal(false);
//   alert(`Loaded "${savedList.name}" successfully!`);
// };

// Also make sure your selectCustomer function works correctly
// const selectCustomer = (customer) => {
//   setSelectedCustomer(customer);
//   setCustomerSearchTerm(customer.name); // This shows the name in the input field
//   setIsCustomerDropdownOpen(false); // This closes the dropdown
//   console.log('Selected customer:', customer);
// };

// const loadList = (savedList) => {
//   // Debug the customer loading
//  // debugCustomerLoad(savedList);
  
//   // Clear existing rows
//   setRows([]);
  
//   // Load products
//   const newRows = savedList.products.map((item, index) => ({
//     id: index + 1,
//     selectedProduct: item.product,
//     quantity: item.quantity,
//     searchTerm: item.product.name,
//     isDropdownOpen: false
//   }));
  
//   setRows(newRows);
//   setRowIdCounter(newRows.length + 1);
  
//   // Load customer information if it exists
//   if (savedList.customer) {
//           // console.log('Loading customer from saved list:', savedList.customer);
    
//     // First, try to find customer by ID
//     let existingCustomer = customers.find(customer => customer.id === savedList.customer.id);
    
//     // If not found by ID, try to find by name (in case IDs don't match)
//     if (!existingCustomer) {
//       existingCustomer = customers.find(customer => 
//         customer.name.toLowerCase() === savedList.customer.name.toLowerCase()
//       );
//     }
    
//     if (existingCustomer) {
//       // Customer exists in the list, select it
//               // console.log(`Found and selected existing customer:`, existingCustomer);
//       setSelectedCustomer(existingCustomer);
//       // ✅ FIX: Update the customerSearchTerm to show the customer name
//       setCustomerSearchTerm(existingCustomer.name);
      
//       // ✅ FIX: Close the dropdown
//       setIsCustomerDropdownOpen(false);
//     } else {
//       // Customer doesn't exist in current list, add it first then select
//       const customerToAdd = {
//         id: savedList.customer.id || Date.now(), // Ensure ID exists
//         name: savedList.customer.name || '',
//         email: savedList.customer.email || '',
//         phone: savedList.customer.phone || '',
//         address: savedList.customer.address || '',
//         createdAt: savedList.customer.createdAt || new Date().toISOString()
//       };
      
//               // console.log('Adding new customer:', customerToAdd);
      
//       // Add to customers list first
//       const updatedCustomers = [...customers, customerToAdd];
//       setCustomers(updatedCustomers);
//       saveCustomersToStorage(updatedCustomers);
      
//       // Then select it
//             // console.log(`Added and selected new customer:`, customerToAdd);
//       setSelectedCustomer(customerToAdd);
//       // ✅ FIX: Update the customerSearchTerm to show the customer name  
//       setCustomerSearchTerm(customerToAdd.name);
      
//       // ✅ FIX: Close the dropdown
//       setIsCustomerDropdownOpen(false);
//     }
    
//   } else {
//     // Clear customer selection if no customer in saved list
//     setSelectedCustomer(null);
//     // ✅ FIX: Clear the search term as well
//     setCustomerSearchTerm('');
    
//     // ✅ FIX: Close the dropdown
//     setIsCustomerDropdownOpen(false);
//     console.log('No customer information found in saved list');
//   }

//   if (savedList.project) {
//         setProjectName(savedList.project);
//    }
//    else
//    {
//       setProjectName('');
//    }
//    if (savedList.notesInfo) {
//         setNotesInfo(savedList.notesInfo);
//    }
//    else
//    {
//       setNotesInfo('');
//    }
  
//   setShowLoadModal(false);
  
//   // Show success message with customer info if available
//   const customerInfo = savedList.customer ? ` for customer: ${savedList.customer.name}` : '';
//   // alert(`Loaded "${savedList.name}"${customerInfo} successfully!`);
//   showSuccess(`Loaded "${savedList.name}"${customerInfo} successfully!`);
// };


// Updated loadList function with ID tracking
  // const loadList = (savedList) => {
  //   console.log('Loading list:', savedList);
    
  //   // 🔥 IMPORTANT: Track the loaded list ID
  //   setCurrentLoadedListId(savedList.id);
    
  //   // Clear existing data
  //   const newRows = [];
    
  //   // Load products (simulated)
  //   if (savedList.products) {
  //     savedList.products.forEach((item, index) => {
  //       newRows.push({
  //         id: index + 1,
  //         selectedProduct: item.product || item,
  //         quantity: item.quantity || 1,
  //         searchTerm: typeof item === 'string' ? item : item.product?.name || item.name,
  //         isDropdownOpen: false
  //       });
  //     });
  //   }

  //   // Load customer information
  //   let loadedCustomer = null;
  //   if (savedList.customer) {
  //     let existingCustomer = customers.find(customer => customer.id === savedList.customer.id);
      
  //     if (!existingCustomer) {
  //       existingCustomer = customers.find(customer =>
  //         customer.name.toLowerCase() === savedList.customer.name.toLowerCase()
  //       );
  //     }
      
  //     if (existingCustomer) {
  //       loadedCustomer = existingCustomer;
  //     } else {
  //       const customerToAdd = {
  //         id: savedList.customer.id || Date.now(),
  //         name: savedList.customer.name || '',
  //         email: savedList.customer.email || '',
  //         phone: savedList.customer.phone || '',
  //         address: savedList.customer.address || '',
  //         createdAt: savedList.customer.createdAt || new Date().toISOString()
  //       };
        
  //       const updatedCustomers = [...customers, customerToAdd];
  //       setCustomers(updatedCustomers);
  //       loadedCustomer = customerToAdd;
  //     }
  //   }

  //   // Update current list data
  //   setCurrentListData({
  //     rows: newRows,
  //     selectedCustomer: loadedCustomer,
  //     projectName: savedList.project || '',
  //     notesInfo: savedList.notesInfo || ''
  //   });

  //   const customerInfo = savedList.customer ? ` for customer: ${savedList.customer.name}` : '';
  //   showSuccess(`Loaded "${savedList.name}"${customerInfo} successfully!`);
  // };
  
const loadList = (savedList) => {
  console.log('Loading list:', savedList.name);
  console.log('Saved list customer data:', savedList.customer);
  console.log('Current customers array length:', customers.length);
  
  // Clear existing rows first
  setRows([]);
  
  // Load products
  const newRows = savedList.products.map((item, index) => ({
    id: index + 1,
    selectedProduct: item.product,
    quantity: item.quantity,
    searchTerm: item.product.name,
    isDropdownOpen: false
  }));
  
  setRows(newRows);
  setRowIdCounter(newRows.length + 1);
  
  // Load customer information if it exists
  if (savedList.customer) {
    console.log('Processing customer from saved list...');
    
    // Create a normalized customer object to ensure all fields exist
    const savedCustomer = {
      id: savedList.customer.id,
      name: savedList.customer.name || '',
      email: savedList.customer.email || '',
      phone: savedList.customer.phone || savedList.customer.contactNumber || '',
      mobile: savedList.customer.mobile || savedList.customer.contactNumber || '',
      address: savedList.customer.address || '',
      contactPerson: savedList.customer.contactPerson || savedList.customer.contact_person || '',
      createdAt: savedList.customer.createdAt || new Date().toISOString()
    };
    
    console.log('Normalized saved customer:', savedCustomer);
    
    // Try to find existing customer by ID first
    let existingCustomer = customers.find(customer => 
      customer.id === savedCustomer.id
    );
    
    // If not found by ID, try to find by name (case-insensitive)
    if (!existingCustomer && savedCustomer.name) {
      existingCustomer = customers.find(customer => 
        customer.name && 
        customer.name.toLowerCase().trim() === savedCustomer.name.toLowerCase().trim()
      );
      console.log('Customer found by name match:', existingCustomer ? 'Yes' : 'No');
    }
    
    // If not found by name, try to find by email
    if (!existingCustomer && savedCustomer.email) {
      existingCustomer = customers.find(customer => 
        customer.email && 
        customer.email.toLowerCase().trim() === savedCustomer.email.toLowerCase().trim()
      );
      console.log('Customer found by email match:', existingCustomer ? 'Yes' : 'No');
    }
    
    if (existingCustomer) {
      // Customer exists in the current list
      console.log('Found existing customer:', existingCustomer.name);
      
      // Ensure the existing customer has all necessary fields
      const customerToSelect = {
        ...existingCustomer,
        // Ensure address field exists - create it if missing
        address: existingCustomer.address || formatAddress(existingCustomer) || 'Address not available'
      };
      
      setSelectedCustomer(customerToSelect);
      setCustomerSearchTerm(customerToSelect.name);
      setIsCustomerDropdownOpen(false);
      
      console.log('Selected existing customer successfully');
    } else {
      // Customer doesn't exist, add it to the list
      console.log('Customer not found in current list, adding new customer...');
      
      // Ensure the customer has a valid address field
      const customerToAdd = {
        ...savedCustomer,
        // Generate a new ID if the saved one might conflict
        id: savedCustomer.id || Date.now(),
        // Ensure address field exists
        address: savedCustomer.address || 'Address not provided'
      };
      
      console.log('Customer to add:', customerToAdd);
      
      // Add to customers list
      const updatedCustomers = [...customers, customerToAdd];
      setCustomers(updatedCustomers);
      
      // Save to storage
      try {
        saveCustomersToStorage(updatedCustomers);
        console.log('Customer saved to storage successfully');
      } catch (error) {
        console.error('Error saving customer to storage:', error);
      }
      
      // Select the new customer
      setSelectedCustomer(customerToAdd);
      setCustomerSearchTerm(customerToAdd.name);
      setIsCustomerDropdownOpen(false);
      
      console.log('Added and selected new customer successfully');
    }
  } else {
    // No customer in saved list, clear selection
    console.log('No customer data in saved list, clearing selection');
    setSelectedCustomer(null);
    setCustomerSearchTerm('');
    setIsCustomerDropdownOpen(false);
  }
  
  // Load project name and notes
  if (savedList.project) {
    setProjectName(savedList.project);
    console.log('Project name loaded:', savedList.project);
  } else {
    setProjectName('');
  }
  
  if (savedList.notesInfo) {
    setNotesInfo(savedList.notesInfo);
    console.log('Notes loaded');
  } else {
    setNotesInfo('');
  }
  
  // Close the load modal
  setShowLoadModal(false);
  
  // Show success message
  const customerInfo = savedList.customer ? ` for customer: ${savedList.customer.name}` : '';
  showSuccess(`Loaded "${savedList.name}"${customerInfo} successfully!`);
  
  console.log('Load list completed successfully');
};

const ensureValidList = (list) => {
  if (!list) return null;
  
  return {
    ...list,
    id: list.id || generateUniqueId(),
    name: list.name || 'Untitled List',
    createdAt: list.createdAt || new Date().toISOString(),
    itemCount: list.itemCount || 0
  };
};

// 4. Clean and validate saved lists
const cleanSavedLists = (lists) => {
  if (!Array.isArray(lists)) return [];
  
  return removeDuplicateLists(
    lists
      .map(ensureValidList)
      .filter(list => list !== null)
  );
};

const removeDuplicateLists = (lists) => {
  const seen = new Set();
  return lists.filter(list => {
    if (!list || !list.id || seen.has(list.id)) {
      return false;
    }
    seen.add(list.id);
    return true;
  });
};
useEffect(() => {
  // Clean the saved lists before setting them
  const cleanedLists = cleanSavedLists(savedLists);
  setModalLists(cleanedLists);
}, [savedLists]);


// useEffect(() => {
//   // Create truly unique lists for modal display
//   const uniqueMap = new Map();
  
//   console.log('🔄 Processing savedLists for modal:', savedLists.length);
  
//   savedLists.forEach((list, index) => {
//     if (!list || !list.id) {
//       console.warn(`⚠️ Invalid list at index ${index}:`, list);
//       return;
//     }
    
//     if (uniqueMap.has(list.id)) {
//       console.warn(`⚠️ Duplicate ID ${list.id} found, skipping`);
//       return;
//     }
    
//     uniqueMap.set(list.id, list);
//   });
  
//   const uniqueArray = Array.from(uniqueMap.values());
//   setModalLists(uniqueArray);
  
//   console.log('✅ Modal lists updated:', uniqueArray.length, 'unique items');
// }, [savedLists]);

// Auto-save current list if not saved
//   const autoSaveCurrentList = (quoteData) => {
//   if (!currentLoadedListId) {
//     // Generate custom name using customer and project
//     const customerName = quoteData.customer?.name || 'Unknown Customer';
//     const projectName = quoteData.projectName || 'Untitled Project';
//     const cleanCustomerName = customerName.length > 30 
//       ? customerName.substring(0, 30) + '...' 
//       : customerName;
//     const customName = `${cleanCustomerName} - ${projectName}`;
    
//     // ✅ FIX: Map your quote data to the expected list structure
//     const newList = {
//       id: generateUniqueKey(),
//       name: customName,
//       createdAt: quoteData.createdAt || new Date().toISOString(),
//       lastModified: new Date().toISOString(),
//       revisionKey: generateRevisionKey(),
//       mailSent: false,
//       mailSentRevisionKey: null,
      
//       // ✅ Map validRows to products with correct structure
//       products: quoteData.validRows.map(row => ({
//         product: {
//           id: row.selectedProduct?.id,
//           name: row.selectedProduct?.name || row.searchTerm,
//           price: row.selectedProduct?.price || 0,
//           unit: row.selectedProduct?.unit || '',
//           category: row.selectedProduct?.category || ''
//         },
//         quantity: row.quantity,
//         subtotal: (row.selectedProduct?.price || 0) * row.quantity
//       })),
      
//       customer: {
//         id: quoteData.customer?.id,
//         name: quoteData.customer?.name,
//         email: quoteData.customer?.email,
//         phone: quoteData.customer?.phone,
//         mobile: quoteData.customer?.mobile,
//         address: quoteData.customer?.address,
//         createdAt: quoteData.customer?.createdAt
//       },
      
//       // ✅ FIXED: Use correct field name
//       project: quoteData.projectName,
      
//       notesInfo: quoteData.notesInfo,
      
//       // ✅ Preserve complete quote financial data
//       quoteData: {
//         subtotal: quoteData.subtotal,
//         tax: quoteData.tax,
//         total: quoteData.total,
//         taxRate: quoteData.tax / quoteData.subtotal,
//         itemCount: quoteData.validRows.length,
//         generatedAt: quoteData.createdAt
//       },
      
//       version: 1
//     };
    
//     const updatedLists = [...lists, newList];
//     saveListsToStorage(updatedLists);
//     setCurrentLoadedListId(newList.id);
    
//     console.log('✅ Auto-saved list:', newList);
//     showSuccess(`Auto-saved list as "${customName}"`);
//     return newList.id;
//   }
  
//   return currentLoadedListId;
// };

const autoSaveCurrentList = (quoteData) => {
  // Generate custom name using customer and project
  const customerName = quoteData.customer?.name || 'Unknown Customer';
  const projectName = quoteData.projectName || 'Untitled Project';
  const cleanCustomerName = customerName.length > 30 
    ? customerName.substring(0, 30) + '...' 
    : customerName;
  const customName = `${cleanCustomerName} - ${projectName}`;

  // Create the list data structure
  const listData = {
    name: customName,
    lastModified: new Date().toISOString(),
    revisionKey: generateRevisionKey(),
    
    // Map validRows to products with correct structure
    products: quoteData.validRows.map(row => ({
      product: {
        id: row.selectedProduct?.id,
        name: row.selectedProduct?.name || row.searchTerm,
        price: row.selectedProduct?.price || 0,
        unit: row.selectedProduct?.unit || '',
        category: row.selectedProduct?.category || ''
      },
      quantity: row.quantity,
      subtotal: (row.selectedProduct?.price || 0) * row.quantity
    })),
    
    customer: {
      id: quoteData.customer?.id,
      name: quoteData.customer?.name,
      email: quoteData.customer?.email,
      phone: quoteData.customer?.phone,
      mobile: quoteData.customer?.mobile,
      address: quoteData.customer?.address,
      createdAt: quoteData.customer?.createdAt
    },
    
    project: quoteData.projectName,
    notesInfo: quoteData.notesInfo,
    
    // Preserve complete quote financial data
    quoteData: {
      subtotal: quoteData.subtotal,
      tax: quoteData.tax,
      total: quoteData.total,
      taxRate: quoteData.tax / quoteData.subtotal,
      itemCount: quoteData.validRows.length,
      generatedAt: quoteData.createdAt
    }
  };

  let updatedLists;
  let targetListId;

  if (!currentLoadedListId) {
    // CREATE NEW LIST
    console.log('📝 Creating new list:', customName);
    
    const newList = {
      id: generateUniqueKey(),
      createdAt: quoteData.createdAt || new Date().toISOString(),
      mailSent: false,
      mailSentRevisionKey: null,
      version: 1,
      ...listData
    };
    
    updatedLists = [...lists, newList];
    targetListId = newList.id;
    setCurrentLoadedListId(newList.id);
    setSavedLists(updatedLists)
    console.log('✅ Created new list:', newList);
    showSuccess(`Auto-saved as new list: "${customName}"`);
    
  } else {
    // UPDATE EXISTING LIST
    console.log('📝 Updating existing list:', currentLoadedListId);
    
    const existingListIndex = lists.findIndex(list => list.id === currentLoadedListId);
    
    

    if (existingListIndex !== -1) {
      const existingList = lists[existingListIndex];
      // Check if this is a significant change (products deleted/modified)
      const oldProductCount = existingList.products?.length || 0;
      const newProductCount = listData.products.length;
      
      console.log(`🔄 Product count change: ${oldProductCount} → ${newProductCount}`);
      const updatedList = {
        ...existingList,
        ...listData,
        version: (existingList.version || 0) + 1,
        // Preserve mailSent status and other metadata
        mailSent:  false, // Reset because content changed      //existingList.mailSent || false,
        mailSentRevisionKey: null // Clear previous mail revision //existingList.mailSentRevisionKey
      };
      
      updatedLists = [
        ...lists.slice(0, existingListIndex),
        updatedList,
        ...lists.slice(existingListIndex + 1)
      ];
      
      targetListId = currentLoadedListId;
      
      console.log('✅ Updated existing list:', updatedList);
      showSuccess(`Auto-saved updates to: "${customName}"`);
      
    } else {
      // Fallback: existing ID not found, create new
      console.warn('⚠️ Existing list ID not found, creating new list');
      
      const newList = {
        id: generateUniqueKey(),
        createdAt: new Date().toISOString(),
        mailSent: false,
        mailSentRevisionKey: null,
        version: 1,
        ...listData
      };
      
      updatedLists = [...lists, newList];
      targetListId = newList.id;
      setCurrentLoadedListId(newList.id);
      
      console.log('✅ Created fallback new list:', newList);
      showSuccess(`Auto-saved as new list: "${customName}"`);
    }
  }

  // Save to storage and update state
  saveListsToStorage(updatedLists);
  // Update BOTH states with new array references
  setLists([...updatedLists]); // ✅ UNCOMMENTED - This is essential!
  setSavedLists([...updatedLists]); // ✅ Update savedLists too
  
  clearrows();
  console.log('📊 Auto-save summary:');
  console.log('  - Target ID:', targetListId);
  console.log('  - Total lists:', updatedLists.length);
  console.log('  - Products in target:', listData.products.length);
  
  return targetListId;
};
  // Delete a saved list
  const deleteList = (listId) => {
    const updatedLists = savedLists.filter(list => list.id !== listId);
    setSavedLists(updatedLists);
    saveListsToStorage(updatedLists);
  };

  // Clear all data
  const clearAll = () => {
    setShowClearModal(true);
  };
  const clearrows = () => {
  // console.log('Starting clear process...');
  
  // ✅ Close all modals
  setShowSaveModal(false);
  setShowClearModal(false);
  setListName('');
  
  // ✅ Clear customer selection first
  setSelectedCustomer(null);
  setCustomerSearchTerm('');
  setIsCustomerDropdownOpen(false);
  
  setProjectName('')
  setNotesInfo('');

  // ✅ Clear rows with proper state management
  setRows([]);
  setRowIdCounter(1);
  
  // console.log('All data cleared, rows:', []);
  
  // ✅ Ensure at least one row exists for new input
  // Choose ONE of these approaches:
  
  // Approach 1: Add empty row immediately
  const newRow = {
    id: 1,
    selectedProduct: null,
    quantity: 1,
    searchTerm: '',
    isDropdownOpen: false
  };
  
  setTimeout(() => {
    setRows([newRow]);
    setRowIdCounter(2);
    // console.log('Added new empty row');
  }, 100);
  
  // alert('All data cleared successfully!');
  showSuccess('All data cleared successfully!');
};

// Alternative: Clear without adding new row
const clearrowsEmpty = () => {
  // console.log('Clearing all data...');
  
  // Close modals
  setShowSaveModal(false);
  setShowClearModal(false);
  setListName('');
  
  // Clear everything
  setRows([]);
  setRowIdCounter(1);
  setSelectedCustomer(null);
  setCustomerSearchTerm('');
  setIsCustomerDropdownOpen(false);
  
  // Log state for debugging
  // console.log('Cleared state:', {
  //   rows: [],
  //   selectedCustomer: null,
  //   customerSearchTerm: '',
  //   listName: ''
  // });
  
  // alert('All data cleared successfully!');
  showSuccess('All data cleared successfully!');
};

  const handleClearAll = () => {
    setSavedLists([]);
    saveListsToStorage([]);
    setRows([getInitialRow()]);
    setRowIdCounter(2);
    dropdownRefs.current = {};
    setShowSaveModal(false);
    setShowLoadModal(false);
    setShowClearModal(false);
    setListName('');
    // alert('All data cleared successfully!');
    showSuccess('All data cleared successfully!');
  };

  // Format last sync time
  const formatLastSync = () => {
    if (!lastSync) return 'Never';
    const now = new Date();
    const diff = now - lastSync;
    const minutes = Math.floor(diff / 60000);
    
    if (minutes < 1) return 'Just now';
    if (minutes < 60) return `${minutes} min ago`;
    if (minutes < 1440) return `${Math.floor(minutes / 60)} hr ago`;
    return lastSync.toLocaleDateString();
  };

  // Get connection status color and text
  const getConnectionStatusDisplay = () => {
    switch (connectionStatus) {
      case 'connected':
        return { color: 'text-green-600', text: 'Connected',icon: '🟢'  };
      case 'failed':
        return { color: 'text-red-600', text: 'Connection Failed' , icon: '🔴' };
      case 'offline':
        return { color: 'text-gray-600', text: 'Offline',icon: '⚫'  };
      default:
        return { color: 'text-yellow-600', text: 'Checking Connection...', icon: '🟡'  };
    }
  };

  const uniqueLists = lists.filter((list, index, arr) => 
  arr.findIndex(l => l.id === list.id) === index
);

//   const statusDisplay = getConnectionStatusDisplay();
  const statusDisplay = getConnectionStatusDisplay(getConnectionStatus());

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-lg shadow-md p-6">
          {/* Enhanced Sync Status Bar */}
          <div className="mb-4 p-3 bg-gray-100 rounded-lg border">
            <div className="flex flex-col sm:flex-row sm:justify-between justify-between items-center">
              <div className="flex flex-wrap items-center gap-4">
                <div className="flex items-center gap-2">
                  {isOnline ? (
                    <Wifi className="w-4 h-4 text-green-500" />
                  ) : (
                    <WifiOff className="w-4 h-4 text-red-500" />
                  )}
                  <span className="text-sm text-gray-600">
                    {isOnline ? 'Online' : 'Offline'}
                  </span>
                </div>
                <div className={`text-sm ${statusDisplay.color}`}>
                    <span className="mr-2">{statusDisplay.icon}</span>
                   {statusDisplay.text}
                  
                </div>
                <div className="text-sm text-gray-600">
                  Products: {products.length}
                </div>
                <div className="text-sm text-gray-600">
                  Customers: {customers.length}
                </div>
                <div className="text-sm text-gray-600">
                  Last sync: {formatLastSync()}
                </div>
                {syncError && (
                  <div className="text-sm text-red-600">
                    Error: {syncError}
                  </div>
                )}
              </div>
              <div className="flex items-center gap-2">
                {/* <button
                  onClick={testConnection}
                  disabled={!isOnline || isLoading}
                  className={`flex items-center gap-1 px-3 py-1 rounded text-sm transition-colors ${
                    isLoading
                      ? 'bg-gray-300 cursor-not-allowed'
                      : 'bg-yellow-500 hover:bg-yellow-600 text-white'
                  }`}
                >
                  Test
                </button> */}
                <label className="flex items-center gap-2 text-sm">
                  <input
                    type="checkbox"
                    checked={autoSync}
                    onChange={(e) => setAutoSync(e.target.checked)}
                    className="rounded"
                  />
                  Auto-sync
                </label>
                <button
                  onClick={handleManualSync}
                  disabled={!isOnline || isLoading}
                  className={`flex items-center gap-1 px-3 py-1 rounded text-sm transition-colors ${
                    isLoading
                      ? 'bg-gray-300 cursor-not-allowed'
                      : 'bg-blue-500 hover:bg-blue-600 text-white'
                  }`}
                >
                  <RefreshCw className={`w-4 h-4 ${isLoading ? 'animate-spin' : ''}`} />
                  {isLoading ? 'Syncing...' : 'Sync'}
                </button>
                <button
                      onClick={handleSimpleLogout}
                      // onClick={handleLogoutClick}
                      className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors flex items-center gap-2"
                      >
                  <LogOut className="w-4 h-4" />
                  Logout
                </button>
              </div>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6 gap-4 sm:gap-0">
            <h2 className="text-xl lg:text-2xl font-bold text-gray-800 flex items-center">
              {/* <ShoppingCart className="mr-2" /> */}
              Quote Request Dashboard
            </h2>
            <div className="flex gap-2">
              <button
                onClick={() => setShowLoadModal(true)}
                className="bg-green-500 hover:bg-green-600 text-white py-2 px-4 rounded-lg transition-colors flex items-center"
              >
                <Download className="w-4 h-4 mr-2" />
                Load List
              </button>
              <button
                onClick={saveCurrentList}
                className="bg-purple-500 hover:bg-purple-600 text-white py-2 px-4 rounded-lg transition-colors flex items-center"
              >
                <Save className="w-4 h-4 mr-2" />
                Save
              </button>
            </div>
          </div>
            <div className="mb-6 p-4 bg-blue-50 rounded-lg border">
            <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
              <User className="mr-2 w-5 h-5" />
              Customer Information
            </h3>
            
            {!showAddCustomerForm ? (
              <>
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                {/* Customer Dropdown */}
                <div className="lg:col-span-2 relative" ref={customerDropdownRef}>
                  <div className="relative">
                    <input
                      type="text"
                      value={customerSearchTerm}
                      onChange={(e) => {
                        setCustomerSearchTerm(e.target.value);
                        setIsCustomerDropdownOpen(true);
                        if (!e.target.value) {
                          setSelectedCustomer(null);
                        }
                      }}
                      onFocus={() => setIsCustomerDropdownOpen(true)}
                      placeholder="Search customers by name, email, or contact person..."
                      className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                    {selectedCustomer ? (
                      <button
                        onClick={() => {
                          setSelectedCustomer(null);
                          setCustomerSearchTerm('');
                          setIsCustomerDropdownOpen(false);
                        }}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 p-1"
                        title="Clear selection"
                      >
                        <X className="w-4 h-4" />
                      </button>
                    ) : (
                    <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                    )}
                    
                    {isCustomerDropdownOpen && (
                      <div className="absolute z-20 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                        {getFilteredCustomers(customerSearchTerm).length > 0 ? (
                          <>
                            {getFilteredCustomers(customerSearchTerm).map(customer => (
                              <div
                                key={customer.id}
                                onClick={() => selectCustomer(customer)}
                                className="px-4 py-3 hover:bg-gray-100 cursor-pointer border-b border-gray-100"
                              >
                                <div className="font-medium text-gray-800">{customer.name}</div>
                                <div className="text-sm text-gray-600">
                                  {customer.email} • {customer.contactPerson}
                                </div>
                              </div>
                            ))}
                            <div className="border-t border-gray-200">
                              <button
                                onClick={() => {
                                  setShowAddCustomerForm(true);
                                  setIsCustomerDropdownOpen(false);
                                }}
                                className="w-full px-4 py-3 text-left hover:bg-gray-100 text-blue-600 font-medium flex items-center"
                              >
                                <Plus className="w-4 h-4 mr-2" />
                                Add New Customer
                              </button>
                            </div>
                          </>
                        ) : (
                          <div className="px-4 py-3">
                            <div className="text-gray-500 mb-2">No customers found</div>
                            <button
                              onClick={() => {
                                setShowAddCustomerForm(true);
                                setIsCustomerDropdownOpen(false);
                              }}
                              className="w-full px-3 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded flex items-center justify-center"
                            >
                              <Plus className="w-4 h-4 mr-2" />
                              Add New Customer
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {/* Selected Customer Address Display */}
                <div className="bg-white p-3 rounded-lg border">
                  {selectedCustomer ? (
                    <div>
                      <div className="flex items-center text-sm font-medium text-gray-700 mb-2">
                        <MapPin className="w-4 h-4 mr-1" />
                        Address
                      </div>
                      <div className="text-sm text-gray-600">
                        <div className="font-medium">{selectedCustomer.name}</div>
                        {/* <div>{selectedCustomer.address}</div>
                        <div className="mt-1">
                          <span className="text-xs">Contact: {selectedCustomer.email && ` ${selectedCustomer.email}`}
                                {selectedCustomer.mobile && ` | ${selectedCustomer.mobile}`}</span>
                        </div> */}
                      </div>
                    </div>
                  ) : (
                    <div className="text-sm text-gray-500 text-center py-4">
                      Select a customer To View Customer information
                    </div>
                  )}
                </div>
              </div>
              <div className='grid grid-cols-1 lg:grid-cols-3 gap-4 py-2'>
                <div className="lg:col-span-2 bg-white p-3 rounded-lg border">
                     <div className="flex items-center text-sm font-medium text-gray-700 mb-2">
                        <Settings className="w-4 h-4 mr-1" />
                        Project Name
                      </div>
                       <div className="relative">
                          <input
                            type="text"
                            value={projectName}
                            onChange={(e) => setProjectName(e.target.value)}
                            placeholder="Enter project name..."
                            className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                          />
                        </div>
                </div>
                
              </div>
              <div className='grid grid-cols-1 lg:grid-cols-3 gap-4 py-2'>
                <div className="lg:col-span-2 bg-white p-3 rounded-lg border">
                     <div className="flex items-center text-sm font-medium text-gray-700 mb-2">
                        <StickyNote className="w-4 h-4 mr-1" />
                        Notes
                      </div>
                       <div className="relative">
                          <textarea
                            type="text"
                            value={notesInfo}
                            onChange={(e) => setNotesInfo(e.target.value)}
                            placeholder="Enter comments or notes to this Quote Request"
                            className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                          />
                        </div>
                </div>
                
              </div>
              </>
            ) : (
              /* Add New Customer Form - Inline */
              <div className="bg-white p-4 rounded-lg border">
                <div className="flex justify-between items-center mb-4">
                  <h4 className="text-md font-semibold text-gray-800">Add New Customer</h4>
                  <button
                    // onClick={() => {
                    //   setShowAddCustomerForm(false);
                    //   setNewCustomer({
                    //     name: '',
                    //     address: '',
                    //     email: '',
                    //     contactNumber: '',
                    //     contactPerson: ''
                    //   });
                    // }}
                    onClick={handleCancel}
                    className="text-gray-400 hover:text-gray-600"
                  >
                    <X className="w-5 h-5" />
                  </button>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Customer Name *
                    </label>
                    <input
                      type="text"
                      value={newCustomer.name}
                      // onChange={(e) => setNewCustomer({...newCustomer, name: e.target.value})}
                      onChange={(e) => handleFieldChange('name', e.target.value)}
                      onBlur={() => handleFieldBlur('name')}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                        errors.name && touched.name ? 'border-red-500' : 'border-gray-300'}`}
                      placeholder="Enter customer name"
                    />
                    {errors.name && touched.name && (
                      <div className="flex items-center mt-1 text-red-600 text-sm">
                        <AlertCircle className="w-4 h-4 mr-1" />
                        {errors.name}
                      </div>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Contact Person *
                    </label>
                    <input
                      type="text"
                      value={newCustomer.contactPerson}
                      // onChange={(e) => setNewCustomer({...newCustomer, contactPerson: e.target.value})}
                      onChange={(e) => handleFieldChange('contactPerson', e.target.value)}
                      onBlur={() => handleFieldBlur('contactPerson')}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                        errors.contactPerson && touched.contactPerson ? 'border-red-500' : 'border-gray-300'}`}
                      placeholder="Contact person name"
                    />
                    {errors.contactPerson && touched.contactPerson && (
                      <div className="flex items-center mt-1 text-red-600 text-sm">
                        <AlertCircle className="w-4 h-4 mr-1" />
                        {errors.contactPerson}
                      </div>
                    )}
                  </div>

                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Address *
                    </label>
                    <textarea
                      value={newCustomer.address}
                      // onChange={(e) => setNewCustomer({...newCustomer, address: e.target.value})}
                      onChange={(e) => handleFieldChange('address', e.target.value)}
                      onBlur={() => handleFieldBlur('address')}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors resize-none ${
                        errors.address && touched.address ? 'border-red-500' : 'border-gray-300' }`}
                      rows="2"
                      placeholder="Enter full address"
                    />
                    {errors.address && touched.address && (
                      <div className="flex items-center mt-1 text-red-600 text-sm">
                        <AlertCircle className="w-4 h-4 mr-1" />
                        {errors.address}
                      </div>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Email *
                    </label>
                    <input
                      type="email"
                      value={newCustomer.email}
                      // onChange={(e) => setNewCustomer({...newCustomer, email: e.target.value})}
                      onChange={(e) => handleFieldChange('email', e.target.value)}
                      onBlur={() => handleFieldBlur('email')}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                        errors.email && touched.email ? 'border-red-500' : 'border-gray-300' }`}
                      placeholder="customer@email.com"
                    />
                    {errors.email && touched.email && (
                      <div className="flex items-center mt-1 text-red-600 text-sm">
                        <AlertCircle className="w-4 h-4 mr-1" />
                        {errors.email}
                      </div>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Contact Number *
                    </label>
                    <input
                      type="tel"
                      value={newCustomer.contactNumber}
                      // onChange={(e) => setNewCustomer({...newCustomer, contactNumber: e.target.value})}
                      onChange={(e) => handleFieldChange('contactNumber', e.target.value)}
                      onBlur={() => handleFieldBlur('contactNumber')}
                      className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
                        errors.contactNumber && touched.contactNumber ? 'border-red-500' : 'border-gray-300' }`}
                      placeholder="+1-555-0123"
                    />
                    {errors.contactNumber && touched.contactNumber && (
                      <div className="flex items-center mt-1 text-red-600 text-sm">
                        <AlertCircle className="w-4 h-4 mr-1" />
                        {errors.contactNumber}
                      </div>
                    )}
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row justify-end gap-2 mt-4">
                  <button
                    onClick={() => {
                      setShowAddCustomerForm(false);
                      setNewCustomer({
                        name: '',
                        address: '',
                        email: '',
                        contactNumber: '',
                        contactPerson: ''
                      });
                    }}
                    className="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors border border-gray-300 rounded-lg"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleAddNewCustomer}
                    className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg transition-colors"
                  >
                    Add Customer
                  </button>
                </div>
              </div>
            )}
          </div>
          

          {/* Rows Container */}
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-gray-800 flex items-center">
              <ShoppingCart className="mr-2" />
              Product Selection
            </h2>
            {rows.map((row, index) => {    //(
              {/*const uniqueKey = `row-${index}-${row.id || Date.now()}`;*/}
              const uniqueKey =generateRowUniqueKey(row, index);
              {/*<div key={row.id} className="border border-gray-200 rounded-lg p-4 bg-gray-50">*/}
              return (
              <div key={uniqueKey} className="border border-gray-200 rounded-lg p-4 bg-gray-50">
                <div className="flex items-center justify-between mb-2">
                 
                  <span className="text-sm font-medium text-gray-600">Product {index + 1}</span>
                     
                          
                  {rows.length > 1 && (
                    <button
                      onClick={() => removeRow(row.id)}
                      className="bg-red-500 hover:bg-red-600 text-white p-1 rounded transition-colors"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  )}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-start">
                  {/* Product Combobox */}
                  <div className="md:block md:col-span-10" >
                    {/* <label className="block text-sm font-medium text-gray-600 mb-2 md:hidden">
                          Product
                        </label> */}
                    <div className="relative" ref={el => dropdownRefs.current[row.id] = el}>
                      <input
                        type="text"
                        value={row.searchTerm}
                        onChange={(e) => updateRow(row.id, {
                          searchTerm: e.target.value,
                          isDropdownOpen: true,
                          selectedProduct: null
                        })}
                        onFocus={() => updateRow(row.id, { isDropdownOpen: true })}
                        placeholder="Search products by name .."
                        className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      />
                      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                      <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                      
                      {/* Enhanced Dropdown */}
                      {row.isDropdownOpen && (
                        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                          {getFilteredProducts(row.searchTerm).length > 0 ? (
                            getFilteredProducts(row.searchTerm).map((product,index) => {
                                 const uniqueKey = `product-${index}-${product.id || product.name}`;
                                 return (
                              <div  
                                key={uniqueKey}
                                onClick={() => selectProduct(row.id, product)}
                                className="px-4 py-3 hover:bg-gray-100 cursor-pointer border-b border-gray-100 last:border-b-0"
                              >
                                <div className="font-medium text-gray-800">{product.name}</div>
                                {/* <div className="text-sm text-gray-600 flex flex-wrap gap-2">
                                  <span>{product.category}</span>
                                  <span>•</span>
                                  <span className="font-medium">${product.price}</span>
                                  {product.code && (
                                    <>
                                      <span>•</span>
                                      <span>Code: {product.code}</span>
                                    </>
                                  )}
                                  {product.sku && (
                                    <>
                                      <span>•</span>
                                      <span>SKU: {product.sku}</span>
                                    </>
                                  )}
                                  {product.quantity !== undefined && (
                                    <>
                                      <span>•</span>
                                      <span className={product.quantity > 0 ? 'text-green-600' : 'text-red-600'}>
                                        Stock: {product.quantity}
                                      </span>
                                    </>
                                  )}
                                </div> */}
                                {product.description && (
                                  <div className="text-xs text-gray-500 mt-1 truncate">
                                    {product.description}
                                  </div>
                                )}
                              </div>
                                 );
                            })) : (
                            <div className="px-4 py-3 text-gray-500">
                              {isLoading ? 'Loading products...' : 
                               products.length === 0 ? 'No products available. Try syncing.' : 
                               'No products found'}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Quantity Input */}
                  
                  <div className="md:col-span-2">
                    {/* <label className="block text-sm font-medium text-gray-600 mb-2">
                        Qty
                      </label> */}
                    <input
                      type="number"
                      value={row.quantity}
                      onChange={(e) => updateRow(row.id, { quantity: parseInt(e.target.value) || 1 })}
                      min="1"
                      placeholder="Qty"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>
                </div>

                {/* Mobile Summary */}
                {/* <div className="md:hidden mt-3 p-3 bg-white rounded border">
                  {row.selectedProduct ? (
                    <div className="grid grid-cols-3 gap-2 text-sm">
                      <div>
                        <span className="text-gray-600">Product:</span>
                        <p className="font-medium">{row.selectedProduct.name}</p>
                      </div>
                      <div>
                        <span className="text-gray-600">Price:</span>
                        <p className="font-medium">${row.selectedProduct.price}</p>
                      </div>
                      <div>
                        <span className="text-gray-600">Total:</span>
                        <p className="font-bold text-green-600">${getRowTotal(row).toFixed(2)}</p>
                      </div>
                    </div>
                  ) : (
                    <p className="text-gray-500 text-sm">No product selected</p>
                  )}
                </div> */}
              </div>
              );
            })}
          </div>

          {/* Grand Total and Actions */}
          {/* <div className="mt-6 flex justify-between items-center">
            <div className="flex gap-2">
              <button
                onClick={clearrows}
                className="bg-yellow-500 hover:bg-yellow-600 text-white py-2 px-4 rounded-lg transition-colors text-sm flex items-center"
              >
                
                <X className="w-4 h-4 mr-2" />
                Clear Rows
              </button>
            
            </div>
            <div className="flex gap-2">
              <button
                onClick={clearAll}
                className="bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded-lg transition-colors text-sm flex items-center"
              >
                <Trash className="w-4 h-4 mr-2" />
                Clear List All
              </button>
              <div className="text-sm text-gray-600 flex items-center">
                Saved Lists: {savedLists.length}
              </div>
            </div>
            <button
              onClick={addRow}
              className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-lg transition-colors flex items-center"
            >
              <Plus className="w-4 h-4 mr-2" />
              Add Row
            </button>
          </div> */}


<div className="mt-6">
  {/* Mobile Layout - Stacked */}
  <div className="flex flex-col gap-3 sm:hidden">
    <div className="flex justify-between items-center">
      <button
        onClick={clearrows}
        className="bg-yellow-500 hover:bg-yellow-600 text-white py-2 px-3 rounded-lg transition-colors text-sm flex items-center"
      >
        <X className="w-4 h-4 mr-1" />
        Clear Rows
      </button>
      
      <button
        onClick={addRow}
        className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-3 rounded-lg transition-colors flex items-center text-sm"
      >
        <Plus className="w-4 h-4 mr-1" />
        Add Row
      </button>
    </div>
    
    <div className="flex justify-between items-center">
      {/* <button
        onClick={clearAll}
        className="bg-red-500 hover:bg-red-600 text-white py-2 px-3 rounded-lg transition-colors text-sm flex items-center"
      >
        <Trash className="w-4 h-4 mr-1" />
        Clear List All
      </button> */}
      
      <div className="text-sm text-gray-600 flex items-center">
        Saved Lists: {savedLists.length}
      </div>
    </div>
  </div>

  {/* Desktop Layout - Single Row */}
  <div className="hidden sm:flex justify-between items-center">
    <div className="flex gap-2">
      <button
        onClick={clearrows}
        className="bg-yellow-500 hover:bg-yellow-600 text-white py-2 px-4 rounded-lg transition-colors text-sm flex items-center"
      >
        <X className="w-4 h-4 mr-2" />
        Clear Rows
      </button>
    </div>
    
    <div className="flex gap-2 items-center">
      {/* <button
        onClick={clearAll}
        className="bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded-lg transition-colors text-sm flex items-center"
      >
        <Trash className="w-4 h-4 mr-2" />
        Clear List All
      </button> */}
      <div className="text-sm text-gray-600 flex items-center">
        Saved Lists: {savedLists.length}
      </div>
    </div>
    
    <button
      onClick={addRow}
      className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-lg transition-colors flex items-center"
    >
      <Plus className="w-4 h-4 mr-2" />
      Add Row
    </button>
  </div>
</div>

           <div className="mt-6 flex justify-between items-center">
              <div className="text-right">
                      <div className="text-sm text-gray-600">
                        Valid Items: {rows.filter(row => row.selectedProduct && row.quantity >= 1).length}
                      </div>
                      {/* <div className="text-lg font-bold text-green-600">
                        Total: ${calculateQuoteTotals().total.toFixed(2)}
                      </div> */}
              </div>
              <div className="flex gap-2">
                  {mailError && (
                    <div className="bg-red-50 border border-red-200 rounded-lg p-3 max-w-md">
                      <div className="flex items-center text-red-800">
                        <AlertCircle className="w-4 h-4 mr-2" />
                        <span className="text-sm font-medium">Validation Error:</span>
                      </div>
                      <p className="text-sm text-red-700 mt-1">{mailError}</p>
                    </div>
                  )}
                  <button
                    onClick={handleSendMail}
                    disabled={isSendingMail}
                    className={`py-2 px-4 rounded-lg  transition-colors flex items-center ${
                      isSendingMail
                        ? 'bg-gray-400 cursor-not-allowed'
                        : 'bg-green-400 hover:bg-green-600'
                    } text-white`}
                  >
                    <Send className={`w-4 h-4 mr-2 ${isSendingMail ? 'animate-pulse' : ''}`} />
                    {isSendingMail ? 'Sending...' : 'Send Mail'}
                  </button>
                </div>
           
  
                    
            </div>
          </div>
        <ToastContainer toasts={toasts} onClose={removeToast} />
        {/* Modals remain the same */}
        {/* Clear All Modal */}
        {showClearModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-96 max-w-90vw">
              <h3 className="text-lg font-bold mb-4">Clear All Data</h3>
              <p className="text-gray-600 mb-4">
                Are you sure you want to clear all data? This will remove all saved lists and reset the current selection.
              </p>
              <div className="flex justify-end gap-2">
                <button
                  onClick={() => setShowClearModal(false)}
                  className="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={handleClearAll}
                  className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg transition-colors"
                >
                  Clear All
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Save Modal */}
        {showSaveModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-96 max-w-90vw">
              <h3 className="text-lg font-bold mb-4">Save Product List</h3>
              <input
                type="text"
                value={listName}
                onChange={(e) => setListName(e.target.value)}
                placeholder="Enter list name..."
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent mb-4"
                onKeyPress={(e) => e.key === 'Enter' && handleSaveList()}
              />
              <div className="flex justify-end gap-2">
                <button
                  onClick={() => setShowSaveModal(false)}
                  className="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSaveList}
                  className="bg-purple-500 hover:bg-purple-600 text-white px-4 py-2 rounded-lg transition-colors"
                >
                  Save List
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Load Modal */}
        {showLoadModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-96 max-w-90vw max-h-80vh overflow-y-auto">
              <h3 className="text-lg font-bold mb-4">Load Saved List</h3>
              {savedLists.length === 0 ? (
                <p className="text-gray-500 text-center py-8">No saved lists found</p>
              ) : (
                <div className="space-y-2 max-h-60 overflow-y-auto">
                  {/*{savedLists.map(list => ( */}
                  { 
                  
                  modalLists
                    .filter((list, index, self) => {
                        // Remove duplicates based on id
                        return list && list.id && self.findIndex(l => l.id === list.id) === index;
                      })
                  .map((list, index)  => {
                    // Additional safety check
                        if (!list || !list.id) {
                          console.error('❌ Invalid list in render:', list);
                          return null;
                        }
                        // Use combination of id and index to ensure uniqueness
                       const uniqueKey = `list-${index}-${list.id || 'no-id'}`;

                        return (
                    
                    <div key={uniqueKey} className="border border-gray-200 rounded-lg p-3 hover:bg-gray-50">
                      <div className="flex justify-between items-start">
                        <div className="flex-1">
                          <h4 className="font-semibold text-gray-800">{list.name}-V{(list.version)}</h4>
                          {/* <p className="text-sm text-gray-600">
                           
                            {list.itemCount} items
                          </p> */}
                          <p className="text-xs text-gray-500">
                            {new Date(list.createdAt).toLocaleDateString()}
                          </p>
                        </div>
                        <div className="flex gap-1">
                          <button
                            onClick={() => loadList(list)}
                            className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-sm transition-colors"
                          >
                            Load
                          </button>
                          <button
                            onClick={() => deleteList(list.id)}
                            className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-sm transition-colors"
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </div>
                        );
                    })}
                </div>
              )}
              <div className="flex justify-end mt-4">
                <button
                  onClick={() => setShowLoadModal(false)}
                  className="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
        {/* Mail Confirmation Modal */}
        {showMailModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
                <h3 className="text-lg font-bold mb-4">Quote Request Summary</h3>
                
                <div className="space-y-3 mb-4">
                  <div className="bg-gray-50 p-3 rounded">
                    <h4 className="font-medium text-gray-800">Customer:</h4>
                    <p className="text-sm text-gray-600">{selectedCustomer?.name}</p>
                    <p className="text-sm text-gray-600">{selectedCustomer?.email}</p>
                  </div>
                  
                  <div className="bg-gray-50 p-3 rounded">
                    <h4 className="font-medium text-gray-800">Project:</h4>
                    <p className="text-sm text-gray-600 overflow-y-auto max-h-32">{projectName}</p>
                  </div>
                  <div className="bg-gray-50 p-3 rounded">
                    <h4 className="font-medium text-gray-800">Notes:</h4>
                    <p className="text-sm text-gray-600 overflow-y-auto max-h-32">{notesInfo}</p>
                  </div>
                  <div className="bg-gray-50 p-3 rounded">
                      <h4 className="font-medium text-gray-800 mb-2">Quote Items:</h4>
                      <div className="space-y-2 max-h-48 overflow-y-auto">
                        {rows
                          .filter(row => row.selectedProduct && row.quantity >= 1)
                          .map((row, index) => {
                            const uniqueKey = `quote-item-${index}-${row.id || Date.now()}`;
                            return (
                            <div key={uniqueKey} className="flex justify-between items-center bg-white p-2 rounded text-sm">
                              <div className="flex-1">
                                <p className="font-medium text-gray-800">{row.selectedProduct.name}</p>
                                {/* <p className="text-xs text-gray-500">
                                  ${row.selectedProduct.price.toFixed(2)} each
                                </p> */}
                              </div>
                              <div className="text-right">
                                <p className="font-medium">Qty: {row.quantity}</p>
                                {/* <p className="text-xs text-green-600 font-bold">
                                  ${(row.selectedProduct.price * row.quantity).toFixed(2)}
                                </p> */}
                              </div>
                            </div>
                            );  
                      })}
                      </div>
                  </div>
                  {/* <div className="bg-gray-50 p-3 rounded">
                    <h4 className="font-medium text-gray-800">Quote Summary:</h4>
                    <p className="text-sm text-gray-600">
                      {calculateQuoteTotals().validRows.length} items
                    </p>
                    <p className="text-sm font-bold text-green-600">
                      Total: ${calculateQuoteTotals().total.toFixed(2)}
                    </p> 
                  </div> */}
                </div>
                
                <div className="flex justify-end gap-2">
                  <button
                    onClick={() => setShowMailModal(false)}
                    disabled={isSendingMail}
                    className="px-4 py-2 rounded-lg bg-orange-300 hover:bg-orange-600 text-gray-700 hover:text-gray-900 transition-colors disabled:opacity-50"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={confirmSendMail}
                    disabled={isSendingMail}
                    className={`px-4 py-2 rounded-lg transition-colors ${
                      isSendingMail
                        ? 'bg-gray-400 cursor-not-allowed'
                        : 'bg-green-500 hover:bg-green-600'
                    } text-white`}
                  >
                    {isSendingMail ? 'Sending...' : 'Send in Mail'}
                  </button>
                </div>
              </div>
            </div>
          )}
      </div>
    </div>
  );
};

export default DynamicProductRows;